/**
 * Created by intellicar-rinas on 4/10/17.
 */
import { schemaTypes, dateFormat } from "../../../../constants/constants";
import ReportAPIs from "../../../../APIs/ReportAPIs";
import actions from "../../../../store/actions";
import _ from "lodash";
import { JSONToCSVConvertor, getCanDataLiveReport } from "../../../../helpers/helperFunctions";
import moment from "moment";
import GeoCodeAPIs from "../../../../APIs/GeoCodeAPIs";
import isGraphVisible from "./graphVisibilityConfig";
import exBlueIcon from "../../../../assets/images/ex-blue.png";
import exGreenIcon from "../../../../assets/images/ex-green.png";
import exOrangeIcon from "../../../../assets/images/ex-orange.png";
import exRedIcon from "../../../../assets/images/ex-red.png";
import exYellowIcon from "../../../../assets/images/ex-yellow.png";
import UserAPIs from "../../../../APIs/UserAPIs";
import refuelmarker from "../../../../components/InMap/Map/Markers/refuel-marker.png";
import pilferagemarker from "../../../../components/InMap/Map/Markers/pilferage-marker.png";
import React from "react";
// import mixpanel from "mixpanel-browser";
let selectedId = null
let gearMeta = null

const processSpeedData = (data, dep) => {
  for (let idx in data) {
    // data[idx].rtgpsIndex =_.sortedIndexBy(dep['getRTGPS'], {time: data[idx].time}, 'time');
    // data[idx].rtgps = dep['getRTGPS'][data[idx].rtgpsIndex];
    // if(!data[idx].rtgps && dep['getRTGPS'][data[idx].rtgpsIndex-1]) {
    //     data[idx].rtgps = dep['getRTGPS'][data[idx].rtgpsIndex-1];
    // }
    // console.log('speed' + data[idx].value + '..');
    let lastvalue = 0;
    if (idx > 0) {
      lastvalue = data[idx - 1].value;
    }

    if (data[idx].value > 200) {
      data[idx].value = lastvalue;
    }

    data[idx].value = data[idx].value > 5 ? data[idx].value : 0;
    // data[idx].value = data[idx].value > 5 ? 300 : 0;
  }
  return data;
};

const processRPMData = (data, dep) => {
  for (let idx in data) {
    if (dep["getRPMInfo"]) {
      data[idx].rpm = (
        dep["getRPMInfo"][
          _.sortedIndexBy(dep["getRPMInfo"], { time: data[idx].time }, "time")
        ] || { rpm: 0 }
      ).value;
    } else {
      data[idx].rpm = 0;
    }
  }
  return data;
};

const processRTGPS = (data, key) => {
  if (!data[0]) return data;

  let initialDistance = data[0].odometer;
  data = data.map((item) => {
    item.distance = item.odometer - initialDistance;
    return item;
  });

  data[0].speed = data[0].speed > 5 && data[0].speed <= 200 ? data[0].speed : 0;
  for (let idx in data) {
    if (idx > 0 && data[idx].speed > 200) {
      data[idx].speed = data[idx - 1].speed;
    }
    data[idx].speed = data[idx].speed > 5 ? data[idx].speed : 0;
    // console.log("rtgps speed", data[idx].speed);
  }

  return data;
};

const processOdometer = (data, key) => {
  if (!data[0]) return data;

  let initialDistance = data[0].value;
  // filter odo values
  data = data
    .filter((f) => f.value > 1 && f.value < 1000000)
    .map((item) => {
      item.distance = item.value - initialDistance;
      return item;
    });
  return data;
};

const processFuelData = (data, dep) => {
  schema.latestFuelDep = dep;
  plotRefuelNPilferageMarkers();

  if(Array.isArray(data)) {
    return data.filter((d) => d.value <= 100 && d.value != 0);
  } else {
    return _.mapValues(data, (d) => d.value <= 100 && d.value != 0);
  }
};

const plotRefuelNPilferageMarkers = (limit) => {
  if (!schema.latestFuelDep) return;
  // filter used for zoom function
  let time_filter = (t) => {
    let filter = (p) =>
      p.starttime > limit.starttime && p.endtime < limit.endtime;
    if (Array.isArray(t)) {
      return t.filter(filter);
    } else {
      let arr = [];
      for (let tankid in t) {
        arr = arr.concat(t[tankid].filter(filter));
      }
      return arr;
    }
  };
  clearRefuelMarkers();
  let refuelreport = schema.latestFuelDep.getRefuelHistory;
  // filter if zoom
  if (limit) refuelreport = _.mapValues(refuelreport, time_filter);
  let refuel_markers = [];
  let rrcb = (p) => {
    let title =
      "Refuel on " +
      moment(p.starttime).format(dateFormat) +
      " | " +
      p.refuelLitres +
      " Ltrs";
    let marker = makeMarker(p, title, refuelmarker);
    refuel_markers.push(marker);
  };
  Object.keys(refuelreport).forEach((k) => {
    let t = refuelreport[k];
    // if data is object means multiple tanks
    if (Array.isArray(t)) {
      t.forEach(rrcb);
    } else {
      for (let tankid in t) {
        t[tankid].forEach(rrcb);
      }
    }
  });
  window.refuelmarkers = refuel_markers;

  clearPilferageMarkers();
  let pilferagereport = schema.latestFuelDep.pilferageReport;
  // filter if zoom
  if (limit) pilferagereport = _.mapValues(pilferagereport, time_filter);
  let pilferage_markers = [];
  let prcb = (p) => {
    let title =
      "Pilferage on " +
      moment(p.starttime).format(dateFormat) +
      " | " +
      p.pilferageLitres +
      " Ltrs";
    let marker = makeMarker(p, title, pilferagemarker);
    pilferage_markers.push(marker);
  };
  Object.keys(pilferagereport).forEach((k) => {
    let t = pilferagereport[k];
    // if data is object means multiple tanks
    if (Array.isArray(t)) {
      t.forEach(prcb);
    } else {
      for (let tankid in t) {
        t[tankid].forEach(prcb);
      }
    }
  });
  window.pilferagemarkers = pilferage_markers;
};

// var canKeys = ['ac', 'enginetemp', 'headLight', 'rpm', 'seatBelt', 'speed',
//     "base_screed_temperature", "left_screed_temperature", "right_screed_temperature",
//     "actualenginespeed", "enginehours", "pavingdistance",
//     "traveldistancehighgear", "traveldistancelowgear", "batterychargeindication",
//     "worktimerlowgearmoving", "worktimerlowgearidle", "screedheatingmode", "worktimehours",
//     "fl", "fr", "rl", "rr", "tfl", "tfr", "trl", "trr"
// ];

const getRTGPSAPI = (asset) => {
  if (asset.type === "user") {
    return UserAPIs.gpsHistory;
  }
  return ReportAPIs.getRTGPS;
};

const processTVSData = (data, listenTo, configIndex, graphConfig) => {
  return data[graphConfig.key];
};

const preProcessRPMData = (data, key) => {
  return data.filter((d) => d.value < 20000);
};

const preProcessEngineTempData = (data, key) => {
  return data.filter((d) => d.value > 0 && d.value < 160);
};

const preProcessClutchData = (data, key) => {
  window.clutchData = data.sort(function (a, b) {
    return a.time - b.time;
  });
};

const preProcessBrakeData = (data, key) => {
  window.brakeData = data.sort(function (a, b) {
    return a.time - b.time;
  });
};

const preProcessAccelData = (data, key) => {
  window.accelData = data.sort(function (a, b) {
    return a.time - b.time;
  });
};

const processGearData = (data) => {
  let gMap = {};
  for (let i in data) {
    let gear = data[i].value;
    if (gear === 0) continue;
    if (!(gear in gMap)) gMap[gear] = 0;
    gMap[gear] += 1;
  }
  return gMap;
};

let APIAndData = {
  getRTGPS: {
    getAPI: getRTGPSAPI,
    status: false,
    data: null,
    listeners: [],
    preProcessData: processRTGPS,
  },
  getClutchData: {
    api: ReportAPIs.getClutchData,
    status: false,
    data: null,
    listeners: [],
    preProcessData: preProcessClutchData,
  },
  getBrakeData: {
    api: ReportAPIs.getBrakeData,
    status: false,
    data: null,
    listeners: [],
    preProcessData: preProcessBrakeData,
  },
  getAccelData: {
    api: ReportAPIs.getAccelData,
    status: false,
    data: null,
    listeners: [],
    preProcessData: preProcessAccelData,
  },
  getRPMInfo: {
    api: ReportAPIs.getRPMInfo,
    status: false,
    data: null,
    listeners: [],
    preProcessData: preProcessRPMData,
  },
  getEngineTempInfo: {
    api: ReportAPIs.getEngineTempInfo,
    status: false,
    data: null,
    listeners: [],
    preProcessData: preProcessEngineTempData,
  },
  getFuelLevelInfo: {
    api: ReportAPIs.getFuelLevelInfo,
    status: false,
    data: { sensors: "all" },
    listeners: [],
    processData: processFuelData,
    dep: ["pilferageReport", "getRefuelHistory"],
  },
  getFuelLevelCombined: {
    api: ReportAPIs.getFuelLevelInfo,
    listeners: [],
    processData: processFuelData,
    dep: ["pilferageReport", "getRefuelHistory"],
  },
  pilferageReport: {
    api: ReportAPIs.pilferageReport,
    status: false,
    data: null,
    listeners: [],
  },
  getRefuelHistory: {
    api: ReportAPIs.getRefuelHistory,
    status: false,
    data: null,
    listeners: [],
  },
  getOdometerInfo: {
    api: ReportAPIs.getOdometerInfo,
    status: false,
    data: null,
    listeners: [],
    preProcessData: processOdometer,
  },
  getBatteryInfo: {
    api: ReportAPIs.getBatteryInfo,
    status: false,
    data: null,
    listeners: [],
  },
  getBatteryTemp: {
    api: ReportAPIs.getBatteryTemp,
    status: false,
    data: null,
    listeners: [],
  },
  getBatteryCurrent: {
    api: ReportAPIs.getBatteryCurrent,
    status: false,
    data: null,
    listeners: [],
  },
  getEvBatteryVoltage: {
    api: ReportAPIs.getEvBatteryVoltage,
    status: false,
    data: null,
    listeners: [],
  },
  
  getBatteryVoltage: {
    api: ReportAPIs.getBatteryVoltage,
    status: false,
    data: null,
    listeners: [],
  },
  getSpeedInfo: {
    api: ReportAPIs.getSpeedInfo,
    status: false,
    data: null,
    listeners: [],
    processData: processSpeedData,
    dep: ["getRTGPS"],
  },
  getHeadLightInfo: {
    api: ReportAPIs.getHeadLightInfo,
    status: false,
    data: null,
    listeners: [],
    processData: processRPMData,
    dep: ["getRPMInfo", "getAlarmHistory"],
  },
  getSeatBeltInfo: {
    api: ReportAPIs.getSeatBeltInfo,
    status: false,
    data: null,
    listeners: [],
    // processData: processRPMData,
    // dep: ["getRPMInfo", "getAlarmHistory"],
  },
  getACInfo: {
    api: ReportAPIs.getACInfo,
    status: false,
    data: null,
    listeners: [],
    // processData: processRPMData,
    // dep: ["getRPMInfo", "getAlarmHistory"],
  },
  getUserScore: {
    api: ReportAPIs.getUserScore,
    status: false,
    data: null,
    listeners: [],
  },
  getAlarmHistory: {
    api: ReportAPIs.getAlarmHistory,
    status: false,
    data: null,
    listeners: [],
  },
  getNanoBatteryInfo: {
    api: ReportAPIs.getNanoBatteryInfo,
    status: false,
    data: null,
    listeners: [],
  },
  getRSSIInfo: {
    api: ReportAPIs.getRSSIInfo,
    status: false,
    data: null,
    listeners: [],
  },
  getMagnetInfo: {
    api: ReportAPIs.getMagnetInfo,
    status: false,
    data: null,
    listeners: [],
  },
  getAmbientLightInfo: {
    api: ReportAPIs.getAmbientLightInfo,
    status: false,
    data: null,
    listeners: [],
  },
  getTPMSHistory: {
    api: ReportAPIs.getTPMSHistory,
    status: false,
    data: null,
    listeners: [],
  },
  getMileage: {
    api: ReportAPIs.getMileage,
    status: false,
    data: null,
    listeners: [],
  },
  getDistance: {
    api: ReportAPIs.getDistance,
    status: false,
    data: null,
    listeners: [],
  },
  getGearStateInfo: {
    api: ReportAPIs.getGearStateInfo,
    status: false,
    data: null,
    listeners: [],
  },
  // Paver APIs
  getBaseScreedTemperature: {
    api: ReportAPIs.getBaseScreedTemperature,
    status: false,
    data: null,
    listeners: [],
  },
  getLeftScreedTemperature: {
    api: ReportAPIs.getLeftScreedTemperature,
    status: false,
    data: null,
    listeners: [],
  },
  getRightScreedTemperature: {
    api: ReportAPIs.getRightScreedTemperature,
    status: false,
    data: null,
    listeners: [],
  },
  getActualEngineSpeed: {
    api: ReportAPIs.getActualEngineSpeed,
    status: false,
    data: null,
    listeners: [],
  },
  getEngineHours: {
    api: ReportAPIs.getEngineHours,
    status: false,
    data: null,
    listeners: [],
  },
  getPavingDistance: {
    api: ReportAPIs.getPavingDistance,
    status: false,
    data: null,
    listeners: [],
  },
  getTravelDistanceHighGear: {
    api: ReportAPIs.getTravelDistanceHighGear,
    status: false,
    data: null,
    listeners: [],
  },
  getTravelDistanceLowGear: {
    api: ReportAPIs.getTravelDistanceLowGear,
    status: false,
    data: null,
    listeners: [],
  },
  getBatteryChargeIndication: {
    api: ReportAPIs.getBatteryChargeIndication,
    status: false,
    data: null,
    listeners: [],
  },
  getLowGearMoving: {
    api: ReportAPIs.getLowGearMoving,
    status: false,
    data: null,
    listeners: [],
  },
  getLowGearIdle: {
    api: ReportAPIs.getLowGearIdle,
    status: false,
    data: null,
    listeners: [],
  },
  getScreenHeatingMode: {
    api: ReportAPIs.getScreenHeatingMode,
    status: false,
    data: null,
    listeners: [],
  },
  getWorkTimeHours: {
    api: ReportAPIs.getWorkTimeHours,
    status: false,
    data: null,
    listeners: [],
  },

  getTemperatureHistory: {
    api: ReportAPIs.getTemperatureHistory,
    status: false,
    data: null,
    listeners: [],
  },

  //Users API
  phoneBatteryHistory: {
    api: UserAPIs.phoneBatteryHistory,
    status: false,
    data: null,
    listeners: [],
  },
  cellInfoHistory: {
    api: UserAPIs.cellInfoHistory,
    status: false,
    data: null,
    listeners: [],
  },

  // TVS apis
  getTvsHistory: {
    api: ReportAPIs.getTvsHistory,
    status: false,
    data: null,
    listeners: [],
  },

  // TORK APIs
  torkCurrentHistory: {
    api: ReportAPIs.torkCurrentHistory,
    status: false,
    data: null,
    listeners: [],
  },
  torkVoltageHistory: {
    api: ReportAPIs.torkVoltageHistory,
    status: false,
    data: null,
    listeners: [],
  },
  throttleInputVoltageHistory: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "throttle_input_voltage" },
    listeners: [],
  },
  ambientTemp: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "ambient_temp" },
    listeners: [],
  },
  getDirection: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "direction" },
    listeners: [],
  },
  getMcuFaultInfo: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "mcu_fault_codes" },
    listeners: [],
  },
  LimpModeInfo: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "limp_home_mode" },
    listeners: [],
  },
  getChargingStatusInfo: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "charging_status" },
    listeners: [],
  },
  getHillAssistInfo: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "hill_assist_status" },
    listeners: [],
  },
  getOverCurrentInfo: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "overcurrent_error" },
    listeners: [],
  },
  getImmobInfo: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "immobilize_sts" },
    listeners: [],
  },
  getImmobEnableInfo: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "immobilize_enable_ack" },
    listeners: [],
  },
  getMotorTempInfo: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "motor_temperature" },
    listeners: [],
  },
  
  driveModeHistory: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "drive_mode" },
    listeners: [],
  },
  maxCellTemp: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "maximum_cell_temperature" },
    listeners: [],
  },
  minTemp: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "t_min" },
    listeners: [],
  },
  avgTemp:{
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "t_average" },
    listeners: [],
  },
  acDcCharging:{
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "ac_dc_charging" },
    listeners: [],
  },
  controllerTemperature: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "controller_temperature" },
    listeners: [],
  },
  bmsTemperature: {
    api: ReportAPIs.graphCanDataDump,
    status: false,
    data: { metrics: ["bms_temperature"] },
    listeners: [],
  },
  minCellTemp: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "minimum_cell_temperature" },
    listeners: [],
  },
  minCellVol: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "minimum_cell_voltage" },
    listeners: [],
  },
  maxCellVol: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "maximum_cell_voltage" },
    listeners: [],
  },
  chargeDischargeCycle: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "charge_cycle" },
    listeners: [],
  },
  throttle: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "acceleration_pedal_position" },
    listeners: [],
  },
  engineSpeedHistory: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "engine_speed" },
    listeners: [],
  },
  brakePedal: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "brake_pedal" },
    listeners: [],
  },
  tempHistory: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "temperature" },
    listeners: [],
  },
  bmsErrorInfo: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "bms_error_info" },
    listeners: [],
  },
  torkMotorTempHistory: {
    api: ReportAPIs.torkMotorTempHistory,
    status: false,
    data: null,
    listeners: [],
  },
  torkECUTempHistory: {
    api: ReportAPIs.torkECUTempHistory,
    status: false,
    data: null,
    listeners: [],
  },
  torkTorqueHistory: {
    api: ReportAPIs.torkTorqueHistory,
    status: false,
    data: null,
    listeners: [],
  },
  // etrio
  torkBatteryVoltageHistory: {
    api: ReportAPIs.torkBatteryVoltageHistory,
    status: false,
    data: null,
    listeners: [],
  },
  torkMinCellVoltageHistory: {
    api: ReportAPIs.torkMinCellVoltageHistory,
    status: false,
    data: null,
    listeners: [],
  },
  torkMaxCellVoltageHistory: {
    api: ReportAPIs.torkMaxCellVoltageHistory,
    status: false,
    data: null,
    listeners: [],
  },
  torkControllerTempHistory: {
    api: ReportAPIs.torkControllerTempHistory,
    status: false,
    data: null,
    listeners: [],
  },
  // KPTL
  pulseHistory: {
    api: ReportAPIs.getPulseHistory,
    status: false,
    data: null,
    listeners: [],
  },
  getPressureHistory: {
    api: ReportAPIs.getHydraulicPressureReport,
    status: false,
    data: null,
    listeners: [],
  },

  // greenfuel
  sohHistory: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "soh" },
    listeners: [],
  },
  chargeTypeHistory: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "charging_type" },
    listeners: [],
  },
  
  dteHistory: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "dte" },
    listeners: [],
  },
  parkingBrakeHistory: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "parking_brake" },
    listeners: [],
  },
  kwhHistory: {
    api: ReportAPIs.getCanReport,
    status: false,
    data: { metricname: "energy" },
    listeners: [],
  },
};

window.graphHistoryStats = {
  maxspeed: 0,
  startodo: 0,
  endodo: 0,
  distance: 0,

  maxspeedCAN: 0,
  startodoCAN: 0,
  endodoCAN: 0,
  distanceCAN: 0,

  startfuel: 0,
  endfuel: 0,
  fuelused: 0,
  mileage: 0,
};

window.clearHistoryReport = () => {
  console.log("Clear History report");
};

const markerRightClickListener = (config) => {
  let failed = false;
  try {
    schema.toolbar[0].ref.setItemById(config.vehicle.vehicleid);
    schema.toolbar[2].ref.setData(config.starttime);
    schema.toolbar[3].ref.setData(config.endtime);
  } catch (e) {
    failed = true;
  }

  if (!failed) {
    schema.noFitBounds = true;
    schema.toolbar[4].triggerClick();
  }
};

setTimeout(() => {
  window.addMarkerRightClickListener("historyReport", markerRightClickListener);
}, 100);

function addAPIListener(listenTo, listener, configIndex) {
  if (listenTo.api in APIAndData) {
    APIAndData[listenTo.api].listeners.push([listener, listenTo, configIndex]);
  }
}
function clearAPIListener(listenTo, listener, configIndex) {
  if (listenTo.api in APIAndData) {
    APIAndData[listenTo.api].listeners = [];
  }
}

const callAPIListener = (schema, key, state,gpsOnly, callback) => {
  let listener;
  if (key in APIAndData) {
    // if(key === "getRTGPS") console.log("key available",APIAndData[key],APIAndData[key].listeners)
    let allGraphs = getAllGraphInstance(schema);
    
    for (let idx in APIAndData[key].listeners) {
      for (let jdx in allGraphs) {
        listener = APIAndData[key].listeners[idx];
        // if(key === "getRTGPS")console.log("listener",listener)
        if (allGraphs[jdx].props.data.key === listener[0]) {
          callback(allGraphs[jdx], listener[1], listener[2], listener[0]);
          break;
        }
      }
    }
  }
  state.dispatch({
    type: actions.GRAPHSET_STATE_CHANGED,
    data: gpsOnly ? state.graphSetState || (gpsOnly ? 50 : 100) : 100,
  });
};

function parseData(data = [], key, starttime, endtime, normalizeXAxis) {
  let arr = [];
  let limit = 1000;
  let skipperRatio = Math.ceil(data.length / limit);
  let counter = 0;
  let idx = 0;
  if (data.length > 0) {
    if (normalizeXAxis) {
      arr.push({ time: starttime, value: data[0][key] });
      arr.push({ time: data[0].time, value: data[0][key] });
    }
    for (idx in data) {
      // if(counter === 0) {
      arr.push({ time: data[idx].time, value: data[idx][key] });
      // }
      // counter = counter === skipperRatio ? 0 : counter + 1;
    }
    if (normalizeXAxis) {
      arr.push({ time: data[idx].time, value: data[idx][key] });
      arr.push({ time: data[idx].time + 1, value: data[idx][key] });
      arr.push({ time: endtime + 2, value: data[idx][key] });
    }
  }
  return arr;
}

function getAllGraphInstance(schema, gpsOnly = null) {
  return [schema.content[0], ...schema.content[1].children]
    .map((g) => {
      let ref = null;
      if (g.ref) {
        ref = g.ref;
        if (ref.ref && ref.ref.wrappedInstance) {
          ref = ref.ref.wrappedInstance;
        } else if (ref.ref && g._ref) {
          ref = g._ref;
        }
      } else if (g._ref) {
        ref = g._ref;
      }
      return ref;
    })
    .filter((i) => {
      return i !== null;
    })
    .filter((i) => {
      return i ? (gpsOnly ? i.props.data.key === "speed" : true) : false;
    });
}

function reqTracker(promise, body, key, callback) {
  promise(body).then(
    (resp) => {
      callback(resp, key, 1);
    },
    (resp) => {
      callback([], key, 0);
    }
  );
}

const getIndex = (data, value, key, left = 0, right = null) => {
  if (!data || !data.length) {
    return null;
  }

  if (data.length === 1) {
    return 0;
  }

  if (right === null) {
    right = data.length - 1;
  }

  if (right - left === 1) {
    return left;
  }

  let point = left + Math.floor((right - left) / 2);

  if (data[point][key] === value) {
    return point;
  } else {
    if (data[point][key] < value) {
      return getIndex(data, value, key, point, right);
    } else {
      return getIndex(data, value, key, left, point);
    }
  }
};

function isValidLatLng(lat, lng) {
  if(!lat || !lng) {
    return false
  }

  if(lat === 0 || lng === 0) {
    return false
  }

  if ((!(lat >= -90 && lat <= 90)) || (!(lng >= -180 && lng <= 180))) {
    return false
  }

  return true
}

const drawTrace = (resp = null, limit = null) => {
  if (resp !== null && resp.length > 0) {
    resp = resp.sort((a, b) => {
      return parseInt(a.time) - parseInt(b.time);
    });
    window.graphControlData = resp;
  }
  // else {
  //   resp = window.graphControlData;
  // }
  if (limit !== null && resp !== null) {
    let startIndex = _.sortedIndexBy(resp, { time: limit.starttime }, "time");
    let endIndex = _.sortedIndexBy(resp, { time: limit.endtime }, "time");
    if (startIndex < resp.length && endIndex < resp.length && resp[startIndex] && resp[endIndex]) {
      let tempArr = [];
      for (let idx = startIndex; idx < endIndex; idx++) {
        tempArr.push(resp[idx]);
      }
      resp = tempArr;
    }
  }

  window.currentPath = resp;

  if (window.InMapForceUpdate) {
    window.InMapForceUpdate();
  }
  if (window.InGraphControlForceUpdate) {
    window.InGraphControlForceUpdate();
  }
  let latLngs = [];
  let position;
  let bounds = new window.google.maps.LatLngBounds();

  for (let idx in resp) {
    let latitude = resp[idx].latitude;
    let longitude = resp[idx].longitude;

    if (!isValidLatLng(latitude, longitude))
      continue
    
    if (latitude < 3 && latitude > -3 && longitude < 3 && longitude > -3)
      continue;

    position = {
      lat: latitude,
      lng: longitude,
    };

    latLngs.push(position);
    bounds.extend(position);
  }

  if (resp && resp.length > 0 && resp[0]) {
    let latitude = resp[0].latitude
    let longitude = resp[0].longitude

    if (window.startMarker) {
      window.startMarker.setVisible(true);
      window.startMarker.setMap(window.map);
      
      if (isValidLatLng(latitude, longitude)) {
        window.startMarker.setPosition({
          lat: latitude,
          lng: longitude,
        });
      }
    }

    if (window.pointerMarker) {
      window.pointerMarker.setVisible(true);
      window.pointerMarker.setMap(window.map);

      if (isValidLatLng(latitude, longitude)) {
        window.pointerMarker.setPosition({
          lat: latitude,
          lng: longitude,
        });
      }
    }

    latitude = resp[resp.length - 1].latitude
    longitude = resp[resp.length - 1].longitude

    if (window.endMarker) {
      window.endMarker.setVisible(true);
      window.endMarker.setMap(window.map);

      if (isValidLatLng(latitude, longitude)) {
        window.endMarker.setPosition({
          lat: latitude,
          lng: longitude,
        });
      }
    }
  }

  if (window.polyline) {
    window.polyline.setMap(null);
  }

  window.polyline = new window.google.maps.Polyline({
    path: latLngs,
    icons: [
      {
        icon: {
          path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
          strokeWeight: 1,
          // strokeColor: "#be3407",
          strokeColor: "#222122",
          fillColor: "#222122",
          fillOpacity: 1,
          scale: 1.5,
        },
        offset: "100%",
        repeat: "100px",
      },
    ],
    geodesic: true,
    strokeColor: "#2569ff",
    strokeOpacity: 1.0,
    strokeWeight: 3,
  });

  if (!window.bufferMapResize) {
    window.setBufferedMapSize();
  }

  if (window.map) {
    window.polyline.setMap(window.map);
    if (window.freezMap.active || schema.noFitBounds) {
      schema.noFitBounds = false;
      window.bufferMapResize = false;
      return;
    }
    if (latLngs.length > 2) {
      window.map.fitBounds(bounds);
    }
  } else {
    console.error("Map Instance not Found!");
  }
};

const processDownloadData = (schema, schemaData, counter = 0) => {
  // this.downloadData = null;

  if (
    window.downloaddatastatus ||
    !window.currentPath ||
    !window.rtgpsdatastatus ||
    !window.alarmdatastatus
  )
    return;

  window.downloaddatastatus = true;

  let data = {};
  let NA = "NA";
  data.startTime = schemaData.starttime.format(dateFormat);
  data.endTime = schemaData.endtime.format(dateFormat);
  data.vehicleno = schemaData.vehicle[0].name;
  data.maxSpeed = window.graphHistoryStats.maxspeed || NA;
  data.endOdo = window.graphHistoryStats.endodo || NA;
  data.startOdo = window.graphHistoryStats.startodo || NA;
  data.tripdistance = window.graphHistoryStats.distance || NA;
  data.endFuel = window.graphHistoryStats.endfuel || NA;
  data.startFuel = window.graphHistoryStats.startfuel || NA;
  data.endFuelPercent = window.graphHistoryStats.endfuelper || NA;
  data.startFuelPercent = window.graphHistoryStats.startfuelper || NA;

  if ((window.graphControlData && !window.graphControlData[0] )|| counter < 10) {
    setTimeout(() => {
      processDownloadData(schema, schemaData, counter + 1);
    }, 300);
    return;
  }

  data.startloc = {
    lat: window.graphControlData[0]
      ? window.graphControlData[0].latitude
      : null,
    lng: window.graphControlData[0]
      ? window.graphControlData[0].longitude
      : null,
  };
  data.endloc = {
    lat: window.graphControlData[window.graphControlData.length - 1].latitude,
    lng: window.graphControlData[window.graphControlData.length - 1].longitude,
  };
  data.alarmProcessed = {};

  for (let idx in window.alarmData) {
    if (
      window.alarmData[idx].alarmtype &&
      window.alarmData[idx].alarmtype.indexOf("_RESOLVED") === -1
    ) {
      if (!(window.alarmData[idx].alarmtype in data.alarmProcessed)) {
        data.alarmProcessed[window.alarmData[idx].alarmtype] = [];
      }
      data.alarmProcessed[window.alarmData[idx].alarmtype].push(
        window.alarmData[idx]
      );
    }
  }

  data.overSpeed = window.alarmData.filter((i) => {
    return (
      i.alarmtype &&
      (i.alarmtype.indexOf("OVERSPEED") !== -1 ||
        i.alarmtype.indexOf("Over_speed_Start") !== -1)
    );
  });
  let jData = [];
  let locationBody = [
    [data.startloc.lat, data.startloc.lng],
    [data.endloc.lat, data.endloc.lng],
  ];

  // GeoCodeAPIs.getAddress(locationBody).then(
  //   (resp) => {
      // data.startLocation = resp[0][1];
      // data.endLocation = resp[1][1];
      addRow("Vehicle No", data.vehicleno, "", "", "", jData);
      addRow("Start Time", data.startTime, "End Time", data.endTime, "", jData);
      addRow(
        "Distance (km)",
        data.tripdistance,
        "Fuel Consumed (ltr)",
        data.fuelused,
        "",
        jData
      );
      addRow(
        "Start Odo (km)",
        data.startOdo,
        "End Odo (km)",
        data.endOdo,
        "",
        jData
      );
      addRow(
        "Start Fuel (%)",
        data.startFuelPercent,
        "End Fuel (%)",
        data.endFuelPercent,
        "",
        jData
      );
      addRow(
        "Start Fuel (ltr)",
        data.startFuel,
        "End Fuel (ltr)",
        data.endFuel,
        "",
        jData
      );
      addRow(
        "Fuel Consumed (ltr)",
        data.fuelused,
        "Mileage (kmpl)",
        data.mileage,
        "",
        jData
      );
      addRow("Start Location", "", "", "", '(' + String(data.startloc.lat) + ',' + String(data.startloc.lng) + ')', jData);
      addRow("End Location", "", "", "", '(' + String(data.endloc.lat) + ',' + String(data.endloc.lng) + ')', jData);

      addRow("", "", "", "", "", jData);
      addRow("Alarm Report", "", "", "", "", jData);

      for (let key in data.alarmProcessed) {
        addRow(key, data.alarmProcessed[key].length, "", "", "", jData);
      }

      addRow("", "", "", "", "", jData);

      addRow("Over Speeding Alerts", data.overSpeed.length, "", "", "", jData);
      if (data.overSpeed.length) {
        for (let idx in data.overSpeed) {
          addRow(
            "Instance " + (parseInt(idx) + 1),
            moment(data.overSpeed[idx].time).format(dateFormat + ":ss"),
            data.overSpeed[idx].speed + " kmph",
            "",
            "",
            jData
          );
        }
      }

      window.downloadData = jData;
    // },
    // (resp) => {
    //   console.log(resp);
    // }
  // );
};

function addRow(d1, d2, d3, d4, d5, data) {
  data.push({
    "col 1": d1,
    "col 2": d2,
    "col 3": d3,
    "col 4": d4,
    "col 5": d5,
  });
}

const graphZoomListener = (event) => {
  try {
    schema.toolbar[2].ref.setData(event.xDomainValue[0]);
    schema.toolbar[3].ref.setData(event.xDomainValue[1]);
    this.zoomTimes = {
      starttime: event.xDomainValue[0],
      endtime: event.xDomainValue[0],
    };
  } catch (e) {}
  drawTrace(window.graphControlData || null, {
    starttime: event.xDomainValue[0],
    endtime: event.xDomainValue[1],
  });
  let dotGraphData = processAlarmData(schema.graphData["getAlarmHistory"], {
    starttime: event.xDomainValue[0],
    endtime: event.xDomainValue[1],
  });
  clearAlarmMarkers();
  plotAlarmsInMap(
    { dispatch: event.dispatch },
    { starttime: event.xDomainValue[0], endtime: event.xDomainValue[1] }
  );
  plotRefuelNPilferageMarkers({
    starttime: event.xDomainValue[0],
    endtime: event.xDomainValue[1],
  });
};

const addLis = () => {
  if (window.addInGraph2Listener) {
    window.addInGraph2Listener("zoom", "historyTrace", graphZoomListener);
  } else {
    setTimeout(addLis, 100);
  }
};

addLis();

const gpsAPIs = ["getRTGPS"];
const shouldIFire = (data, key, vehicle, gpsOnly) => {
  /*
   *   Filter here
   * */
  if (gpsOnly && gpsAPIs.indexOf(key) === -1) {
    return false;
  }

  return true;
};

const getStats = (schema, data, state, item) => {
  getHistory(schema, data, state, item, false);
};

window.getGraphDataObject = (key, time) => {
  return schema.graphData && schema.graphData[key]
    ? schema.graphData[key][
        _.sortedIndexBy(schema.graphData[key], { time }, (o) => {
          return o.time;
        })
      ]
    : {};
};

const processStats = (data, key) => {

  if (key === "getDistance") {
    window.graphHistoryStats.distance = data.gpsdistance;
 }

  // let vm =
  // window.selectedVehicles && window.selectedVehicles[0]
  //   ? window.selectedVehicles[0].data
  //   : null;
// if(vm.vehiclemeta && vm.vehiclemeta.odofrom && vm.vehiclemeta.odofrom=="gps_odometer"){
//   const calibList = vm.vehiclemeta.odocalibration;
//   for(let i in data){
//     for (let j=calibList.length-1; j>=0; j--) {
//       if (calibList[j][0] > data[i].time || calibList[j][0] == 0) {
//         data[i].odometer += parseInt(calibList[j][2]);
//         break;
//       }
//     }
//   }
// }

  if (key === "getRTGPS") {
    for (let idx in data) {
      if (!data[idx]) continue;
      if (data[idx].speed > window.graphHistoryStats.maxspeed) {
        window.graphHistoryStats.maxspeed = data[idx].speed;
      }
    }
    if (data[0]) {
      window.graphHistoryStats.startodo = data[0].odometer;
      window.graphHistoryStats.startodotime = data[0].time;
      window.graphHistoryStats.endodo = data[data.length - 1].odometer;
      window.graphHistoryStats.endodotime = data[data.length - 1].time;
    }
  }

  if (key === "getSpeedInfo" && data.length > 0) {
    for (let idx in data) {
      if (!data[idx]) continue;
      if (data[idx].value > (window.graphHistoryStats.maxspeedCAN || 0)) {
        window.graphHistoryStats.maxspeedCAN = data[idx].value || 0;
      }
    }
  }
  // random fix
  // added data[0]
  if (data && data[0]) {
    let vehicle =
      window.selectedVehicles && window.selectedVehicles[0]
        ? window.selectedVehicles[0].data
        : null;
    let isCANOdo =
      vehicle && vehicle.vehiclemeta ? vehicle.vehiclemeta.odofrom : "";
    isCANOdo = isCANOdo === "can_odometer" || isCANOdo === "can_odc";
    if (key === "getOdometerInfo" && data.length > 0 && isCANOdo) {
      window.graphHistoryStats.startodoCAN = data[0].value;
      window.graphHistoryStats.endodoCAN = data[data.length - 1].value;
      window.graphHistoryStats.distanceCAN =
        window.graphHistoryStats.endodoCAN -
        window.graphHistoryStats.startodoCAN;
    }
    if (key === "getFuelLevelInfo" && data.length > 0) {
      window.graphHistoryStats.endfuel2 = data[data.length - 1]
        ? data[data.length - 1].value
        : 0;
      window.graphHistoryStats.startfuel2 = data[0] ? data[0].value : 0;

      if (window.graphHistoryStats.getfuelfailed) {
        window.graphHistoryStats.endfuel = window.graphHistoryStats.endfuel2;
        window.graphHistoryStats.startfuel =
          window.graphHistoryStats.startfuel2;
      }
    }
  }
  setMileage();
};

const setMileage = () => {
  if (
    window.graphHistoryStats.startodoCAN !== 0 &&
    window.graphHistoryStats.fuelused !== 0
  ) {
    window.graphHistoryStats.mileage =
      window.graphHistoryStats.distance / window.graphHistoryStats.fuelused;
  }
};

const handleFuelConsumed = (resp) => {
  window.graphHistoryStats.fuelused = resp.fuelused;
  window.graphHistoryStats.startfuel = resp.startfl;
  window.graphHistoryStats.endfuel = resp.endfl;
  setMileage();
};

const handleFuelConsumedFailure = (resp) => {
  if (window.graphHistoryStats.endfuel2) {
    window.graphHistoryStats.endfuel = window.graphHistoryStats.endfuel2;
    window.graphHistoryStats.startfuel = window.graphHistoryStats.startfuel2;
  } else {
    window.graphHistoryStats.getfuelfailed = true;
  }
  // setMileage();
};

const processBarGraphs = (resp, schema) => {
  // console.log("calling processBarGraphs",resp)
  let ignitionData = [];
  let engineData = [];
  let speedData = [];

  let ignitionObject = null;
  let engineObject = null;
  let speedObject = null;

  for (let idx in resp) {
    if (resp[idx].ignstatus && ignitionObject === null) {
      ignitionObject = { left: resp[idx].time };
    } else if (!resp[idx].ignstatus && ignitionObject !== null) {
      ignitionData.push({ ...ignitionObject, right: resp[idx].time });
      ignitionObject = null;
    }

    if (resp[idx].ignstatus > 4 && engineObject === null) {
      engineObject = { left: resp[idx].time };
    } else if (resp[idx].ignstatus <= 4 && engineObject !== null) {
      engineData.push({ ...engineObject, right: resp[idx].time });
      engineObject = null;
    }

    if (resp[idx].speed >= 5 && speedObject === null) {
      speedObject = { left: resp[idx].time };
    } else if (resp[idx].speed < 5 && speedObject !== null) {
      speedData.push({ ...speedObject, right: resp[idx].time });
      speedObject = null;
    }
  }
  if (ignitionObject) {
    ignitionData.push({ ...ignitionObject, right: resp[resp.length - 1].time });
  }
  if (engineObject) {
    engineData.push({ ...engineObject, right: resp[resp.length - 1].time });
  }
  if (speedObject) {
    speedData.push({ ...speedObject, right: resp[resp.length - 1].time });
  }

  let barGraphData = [
    { data: ignitionData, color: "#3498db" },
    { data: speedData, color: "#2ecc71" },
    { data: engineData, color: "#DB6D1E" },
  ];
  let allGraphs = getAllGraphInstance(schema);

  if (allGraphs[0]) {
    if(allGraphs[0].setBarGraphData)allGraphs[0].setBarGraphData(barGraphData);
    if(allGraphs[0].draw)allGraphs[0].draw();
  }
};

const getIcon = (data) => {
  let iconImage = null;

  if (data.iconImage) {
    return data.iconImage;
  }

  if (!data.resolved) {
    switch (data.key) {
      case "csa":
        iconImage = exBlueIcon;
        break;

      case "custom":
        iconImage = exOrangeIcon;
        break;

      case "dtc":
        iconImage = exRedIcon;
        break;

      default:
        iconImage = exYellowIcon;
        break;
    }
  } else {
    iconImage = exGreenIcon;
  }

  return iconImage;
};

const clearAlarmMarkers = () => {
  if (window.alarmMarkers) {
    for (let idx in window.alarmMarkers) {
      if (window.alarmMarkers[idx] && window.alarmMarkers[idx].setMap) {
        window.alarmMarkers[idx].setMap(null);
      }
    }
  }
  window.alarmMarkers = [];
};

window.toggleAlarmMarkers = (state) => {
  state.dispatch({ type: actions.TOGGLE_ALARM });
  schema.showAlarms = !schema.showAlarms;
  drawAlarmMarkers(state);
};
const drawAlarmMarkers = (state) => {
  clearAlarmMarkers();
  let starttime = schema.toolbar[2].ref.value;
  let endtime = schema.toolbar[3].ref.value;
  let timerange =
    starttime && endtime
      ? {
          starttime: moment(starttime, dateFormat).valueOf(),
          endtime: moment(endtime, dateFormat).valueOf(),
        }
      : null;
  plotAlarmsInMap(state, timerange);
};

const plotAlarmsInMap = (state, timefilter) => {
  if (!schema.showAlarms) return;

  let alarmData = this.alarmData;

  for (let idx in alarmData) {
    let ad = alarmData[idx];
    let items = ad.data;
    if (timefilter)
      items = items.filter(
        (f) => f.time > timefilter.starttime && f.time < timefilter.endtime
      );
    for (let jdx in items) {
      let at = items[jdx];
      if (at.alarmtype) {
        let alarmtype = at.alarmtype;
        if (alarmtype && alarmtype.toLowerCase().indexOf("idling") > -1) {
        } else if (
          alarmtype &&
          alarmtype.toLowerCase().indexOf("ignition_key") > -1
        ) {
        } else if (
          alarmtype &&
          alarmtype.toLowerCase().indexOf("offroading") > -1
        ) {
        }
        let marker = new window.google.maps.Marker({
          title: alarmtype,
          data: at,
          icon: getIcon(at),
          map: window.map,
          position: { lat: at.lat, lng: at.lng },
        });
        marker.addListener("click", function () {
          state.dispatch({
            type: actions.ADD_INTOAST,
            data: {
              name:
                this.data && this.data.name
                  ? this.data.name.split("_").join(" ")
                  : "Unknown",
              content:
                "Time : " + moment(this.data.data.time).format(dateFormat),
              replace: true,
              createAt: Date.now(),
            },
          });
          window.updateTimeline(this.data.data.time);
        });

        if (!window.alarmMarkers) window.alarmMarkers = [];
        window.alarmMarkers.push(marker);
      }
    }
  }
};

const processDotGraphs = (dotGraphData, schema) => {
  let allGraphs = getAllGraphInstance(schema);
  if (allGraphs[0]) {
    allGraphs[0].setDotGraphData(dotGraphData);
    allGraphs[0].draw();
  }
};

const processAlarmData = (resp, range = null) => {
  if (!resp || !resp[Object.keys(resp)[0]]) return;

  let data = resp[Object.keys(resp)[0]];
  let alarms = [];
  let alarmColorMap = {
    csa: "#296aff",
    custom: "#ff9502",
    dtc: "#ff2025",
    standard: "#f4ff10",
  };
  let dotGraphData = [];
  window.alarmData = [];
  if (data) {
    for (let key in alarmColorMap) {
      if (data[key]) {
        alarms = data[key];
        alarms = alarms.map((d) => {
          let name = (d.alarmtype || "").toLowerCase().trim();
          if (name.indexOf("speed") !== -1) {
            d.color = "#ff0000" || alarmColorMap[key];
            d.iconImage = exRedIcon;
          }
          return d;
        });
        if (range) {
          alarms = alarms.filter((d) => {
            return d.time >= range.starttime && d.time <= range.endtime;
          });
        }
        window.alarmData.push(...alarms);
        dotGraphData.push({
          key,
          color: alarmColorMap[key],
          data: alarms,
        });
      }
    }
  }
  return dotGraphData;
};

const checkDep = (data, config) => {
  let dep = config.dep ? config.dep : [];
  for (let idx in dep) {
    if (!data[dep[idx]]) {
      return false;
    }
  }
  return true;
};

let unprocessedResp = {};

const normalizeXAxis = (graph) => {
  return (
    graph.props &&
    graph.props.data &&
    [
      "odometer",
      "battery",
      "fuellevel",
      "odometerGPS",
      "distance",
      "distanceGPS",
    ].indexOf(graph.props.data.key) !== -1
  );
};

export const before_buffer = (p, fuellevels) => {
  let filtered = fuellevels.filter(
    (f) => f.time > p.starttime - 60000 && f.time < p.starttime
  );
  return filtered.length ? filtered[filtered.length - 1] : [];
};
export const after_buffer = (p, fuellevels) => {
  let filtered = fuellevels.filter(
    (f) => f.time > p.endtime && f.time < p.endtime + 60000
  );
  return filtered.length ? filtered[0] : [];
};
const getHistory = (schema, data, state, item, gpsOnly = true) => {
  let firedAPICount = 0
  let responedAPICount = 0
  // mixpanel.track("User Looks For History Report", {
  //   Platform: "Web",
  //   Application: "Web",
  //   Screen: "Report",
  // });
  // this.gpsOnly = gpsOnly;
  if (window.setReportWindowTabBusy)
    window.setReportWindowTabBusy(schema, true);

  //if (!data.vehicle[0] || !data.starttime || !data.endtime) return;

  let reqTime = Date.now();
  let starttime = data.starttime.unix() * 1000;
  let endtime = data.endtime.unix() * 1000;
  window.historyStartTime = starttime
  window.historyEndTime = endtime
  // this.starttime = starttime;
  // this.endtime = endtime;

  window.graphDataErr = "";
  if (!data || !data.vehicle || !data.vehicle[0]) {
    window.graphControlData = null;
    window.graphDataErr = "Please Select Vehicle";

    if (window.InMapForceUpdate) {
      window.InMapForceUpdate();
    }
    if (window.InGraphControlForceUpdate) {
      window.InGraphControlForceUpdate();
    }
    state.dispatch({
      type: actions.GRAPHSET_STATE_CHANGED,
      data: 0,
    });
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, false);
    return;
  }

  if (starttime > endtime) {
    window.graphControlData = null;
    window.graphDataErr = "Start time is greater than End time";

    if (window.InMapForceUpdate) {
      window.InMapForceUpdate();
    }
    if (window.InGraphControlForceUpdate) {
      window.InGraphControlForceUpdate();
    }
    state.dispatch({
      type: actions.GRAPHSET_STATE_CHANGED,
      data: 0,
    });
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, false);
    return;
  }

  if (endtime - starttime > 1000 * 60 * 60 * 24 * 35) {
    window.graphControlData = null;
    window.graphDataErr = "Please Select A Time Range Less Than 35 Days";

    if (window.InMapForceUpdate) {
      window.InMapForceUpdate();
    }
    if (window.InGraphControlForceUpdate) {
      window.InGraphControlForceUpdate();
    }
    state.dispatch({
      type: actions.GRAPHSET_STATE_CHANGED,
      data: 0,
    });
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, false);
    return;
  }
  window.callGraphListeners("graphBroadcast", { clearData: true });
  // this.downloadData = null;

  let graphs = getAllGraphInstance(schema);
  if (graphs && graphs[0]) {
    if(graphs[0].setBarGraphData) graphs[0].setBarGraphData([]);
    if(graphs[0].setDotGraphData) graphs[0].setDotGraphData([]);
  }
  graphs.map((graph) => {
    if(graph.setNoData)return graph.setNoData(true);
  });
  graphs.map((graph) => {
    if(graph.setBusy)return graph.setBusy(true);
  });

  window.currentPath = null;
  window.rtgpsdatastatus = false;
  window.alarmdatastatus = false;
  window.downloaddatastatus = false;

  // this.graphData = {};
  schema.graphData = {}
  window.graphData = {};
  unprocessedResp = {};

  window.graphHistoryStats = {
    maxspeed: 0,
    startodo: null,
    endodo: null,
    startfuel: 0,
    endfuel: 0,
    distance: 0,
    fuelused: 0,
    mileage: 0,
  };
  // window.distanceOdo = {
  //   distance :0,
  //   startodo :null,
  //   endodo : null,
  // }

  window.initialXDomain = [starttime, endtime];

  const drawGraph = (resp, key) => {
    const callback = (graph, listenTo, configIndex, graphKey) => {
      if (listenTo.noDraw) return;
      const config = graph.props.data.config[configIndex];
      if(config.condition && !config.condition(data.vehicle[0])) return;
      // console.log("config",config)
        let respData = [];
        if (graph.props.data.processData) {
          respData =
            _.cloneDeep(
              graph.props.data.processData(
                resp,
                listenTo,
                configIndex,
                graph.props.data
              )
            ) || [];
        } else {
          respData = resp;
          // if(graphKey === "gpsspeed") console.log("respData",respData,listenTo.processData,config)
        }
        if(listenTo.processData) respData = listenTo.processData(respData, data.vehicle[0]);
        let parsedData = respData;

        if (!('multiLineNames' in config)) {
          parsedData = parseData(
            respData,
            listenTo.key,
            starttime,
            endtime,
            normalizeXAxis(graph)
          );
          // if(graphKey === "gpsspeed") console.log("parsedData",parsedData)
        } else {

          parsedData = [];
          for (let idx in respData) {
            parsedData[idx] = parseData(
              respData[idx],
              listenTo.key,
              starttime,
              endtime,
              normalizeXAxis(graph)
            );
          }
          // if(graphKey === "gpsspeed") console.log("parsedData", parsedData)
        }

        if (
          listenTo.api in APIAndData &&
          APIAndData[listenTo.api].processData
        ) {

          // console.log(" schema.graphData", schema.graphData)
          parsedData = APIAndData[listenTo.api].processData(
            parsedData,
            schema.graphData
          );
        }

        if (!parsedData.length && key == "getRTGPS") {
          if (window.startMarker) {
            window.startMarker.setMap(null);
            window.pointerMarker.setMap(null);
            window.endMarker.setMap(null);
          }
        }
        if(graph.draw) {

          graph.draw(
            {
              data: key === "getTPMSHistory" ? parsedData : [parsedData],
              axis: configIndex,
              reqTime,
              priority: listenTo.priority || 0,
            },
            {
              xDomainValue: [starttime, endtime],
              shapes: getShapes(key, graph.props.data),
            },
            key,
            graphKey
          );
        }
    }
    
    callAPIListener(schema, key, state,gpsOnly, callback);
  };

  const getShapes = (key, config) => {
    const num_fuelsensors = _.get(window.selectedVehicles, '0.data.vehiclemeta.num_fuelsensors');
    let isFuelGraph = false;
    if(num_fuelsensors === 2 && key === "getFuelLevelCombined") isFuelGraph = true;
    else if(key === "getFuelLevelInfo") isFuelGraph = true;
    if (isFuelGraph) {
      let refuelPoints = [];

      let pilferagePoints = [];

      let refuelreport = schema.latestFuelDep.getRefuelHistory;
      let pilferagereport = schema.latestFuelDep.pilferageReport;
      let fuellevels = schema.latestFuelDep[key];
      
      // if (Array.isArray(fuellevels))
      //   fuellevels = fuellevels.filter((f) => f.value <= 100);
      // else
      //   for (let i in fuellevels) {
      //     fuellevels[i] = fuellevels[i].filter((f) => f.value <= 100);
      //   }

      // console.log(fuellevels);
      // console.log(refuelreport);
      let filter_criteria = (p) => (f) =>
        f.time > p.starttime && f.time < p.endtime;
      // used to collect fuelevel points during refuel/pilferage
      let pointCollector = (target, fuellevels) => (p) => {
        let points = [];
        // add the fuellevel point before starttime
        points = points.concat(before_buffer(p, fuellevels));
        points = points.concat(fuellevels.filter(filter_criteria(p)));
        // add the fuellevel point after refuel endtime
        points = points.concat(after_buffer(p, fuellevels));
        target.push(points);
      };
      // populate refuel data
      Object.keys(refuelreport).forEach((vid) => {
        let t = refuelreport[vid];
        if (Array.isArray(fuellevels)) {
          t.forEach(pointCollector(refuelPoints, fuellevels));
          // multitank looks like an object, retrieve tank id from config
        } else if (Array.isArray(t[config.tankid])) {
          t[config.tankid].forEach(
            pointCollector(refuelPoints, fuellevels[config.tankid])
          );
        }
      });
      // populate pilferage data
      Object.keys(pilferagereport).forEach((vid) => {
        let t = pilferagereport[vid];
        if (Array.isArray(fuellevels)) {
          t.forEach(pointCollector(pilferagePoints, fuellevels));
          // multitank looks like an object, retrieve tank id from config
        } else if (Array.isArray(t[config.tankid])) {
          t[config.tankid].forEach(
            pointCollector(pilferagePoints, fuellevels[config.tankid])
          );
        }
      });
      // make shapes config for refuel, pilferage
      return refuelPoints
        .map((r) => ({
          strokeOpacity: 1,
          stroke: "#0f0",
          axis: 0,
          type: "path",
          data: r,
        }))
        .concat(
          pilferagePoints.map((p) => ({
            strokeOpacity: 1,
            stroke: "#f00",
            axis: 0,
            type: "path",
            data: p,
          }))
        );
    }
    return [];
  };

  const handleResponse = (resp, key, status) => {
    // console.log("handleResponse",key,resp)
    responedAPICount++;
    if (status === 0) {
      resp = [];
    }

    if (APIAndData[key].preProcessData) {
      resp = APIAndData[key].preProcessData(resp);
    }

    schema.graphData[key] = resp;
    window.graphData[key] = resp;
    // console.log(schema.graphData)
    processStats(resp, key);

    for (let idx in unprocessedResp) {
      if (checkDep(schema.graphData, APIAndData[idx])) {
        // console.log(idx,"################")
        unprocessedResp[idx]();
        delete unprocessedResp[idx];
      }
    }

    if (!checkDep(schema.graphData, APIAndData[key])) {
      unprocessedResp[key] = () => drawGraph(resp, key);
    } else {
      drawGraph(resp, key);
    }

    if (key === "getRTGPS") {
      drawTrace(resp);
      processBarGraphs(resp, schema);
      window.rtgpsdatastatus = true;
    }

    let vehicle = (data.vehicle[0] || {}).data;
    let isEVBike =
      vehicle &&
      vehicle.vehicleModel &&
      (vehicle.vehicleModel.fueltype || "").toLowerCase() === "ev" &&
      (vehicle.vehicleModel.vehicletype || "").toLowerCase() === "bike"
        ? true
        : false;

    if (key === "getAlarmHistory" && !isEVBike) {
      let dotGraphData = processAlarmData(resp);
      // this.alarmData = dotGraphData;
      drawAlarmMarkers(state);
      processDotGraphs(dotGraphData, schema);
      window.alarmdatastatus = true;
    }
    processDownloadData(schema, data);
    // if (this.firedAPICount === this.responedAPICount) {
    if (firedAPICount === responedAPICount) {
      // console.log(firedAPICount,responedAPICount)

      if (window.setReportWindowTabBusy)
        window.setReportWindowTabBusy(schema, false);
    }
  };

  state.dispatch({
    type: actions.SELECTED_VEHICLE_UPDATED,
    data: data.vehicle,
  });
  window.selectedVehicles = data.vehicle;

  let body = {
    vehicleid: data.vehicle[0].data.vehicleid,
    userid: data.vehicle[0].data.vehicleid,
    vehicletype: "Vehicle",
    starttime,
    endtime,
    numpoints: 0,
    bucketPeriod: 60,
    vehicleno: data.vehicle[0].data.vehicleno,
  };

  let body2 = {
    vehicleid: [data.vehicle[0].data.vehicleid],
    userid: [data.vehicle[0].data.vehicleid],
    vehicletype: "Vehicle",
    starttime,
    endtime,
    numpoints: 0,
    bucketPeriod: 60,
  };

  let body3 = {
    vehicleid: [data.vehicle[0].data.vehicleid],
    userid: [data.vehicle[0].data.vehicleid],
    vehicletype: "Vehicle",
    starttime,
    endtime,
    numpoints: 0,
    bucketPeriod: 60,
  };

  // essentialy body without numpoints
  let body4 = {
    vehicleid: data.vehicle[0].data.vehicleid,
    userid: data.vehicle[0].data.vehicleid,
    vehicletype: "Vehicle",
    starttime,
    endtime,
    numpoints: 0,
    bucketPeriod: 60,
  };

  if(window.showNoGpsFixData == true){
    body.fixqfilter = false
    body2.fixqfilter = false
    body3.fixqfilter = false
    body4.fixqfilter = false
  }
  // if(window.rawData == false){
  //   body.numpoints = 300
  //   body2.numpoints = 300
  //   body3.numpoints = 300
  //   body4.numpoints = 300
  // }
  const handleSummary = (resp) => {
    let  data = resp[body.vehicleid] ? resp[body.vehicleid] : []
    window.batteryUsed = {
      // distance : data[0].tripdistance,
      // startodo : data[0].startodo,
      // endodo :data[0].endodo,
      fuelused: data[0].fuelused
    }
  }
  ReportAPIs.getPrecomputeSummarytrips(body).then(handleSummary, (r) => {
    handleSummary({});
  });

  ReportAPIs.getFuelConsumed(body).then(
    handleFuelConsumed,
    handleFuelConsumedFailure
  );

  let failed = {};
  let allowedGraphs = [schema.content[0], ...schema.content[1].children].filter(
    (graph) => {
      return isGraphVisible(graph);
    }
  );
  let allowedAPIs = [];

  for (let idx in allowedGraphs) {
    for (let jdx in allowedGraphs[idx].config) {
      allowedAPIs.push(
        ...allowedGraphs[idx].config[jdx].listenTo.map((i) => {
          return i.api;
        }),
        ...(allowedGraphs[idx].depAPIs || [])
      );
    }
  }

  // this.firedAPICount = 0;
  // this.responedAPICount = 0;
  for (let key in APIAndData) {
    if (
      shouldIFire(APIAndData[key], key, data.vehicle[0], gpsOnly) &&
      (allowedAPIs.indexOf(key) !== -1 || key === "getAlarmHistory")
    ) {
      for (let idx in APIAndData[key].listeners) {
        failed[APIAndData[key].listeners[idx][0]] = false;
      }
      // this.firedAPICount++;
      firedAPICount++;
      if (
        ["getAlarmHistory", "getRefuelHistory", "pilferageReport"].indexOf(
          key
        ) !== -1
      ) {
        reqTracker(APIAndData[key].api, body2, key, handleResponse);
      } else if (
        [
          "getFuelLevelInfo",
          "getHeadLightInfo",
          "getSeatBeltInfo",
          "getACInfo",
        ].indexOf(key) !== -1
      ) {
        reqTracker(
          APIAndData[key].api,
          { ...body3, ...APIAndData[key].data },
          key,
          handleResponse
        );
      } else if (["getRTGPS"].includes(key)) {
        reqTracker(
          APIAndData[key].getAPI(getVehicle()),
          body4,
          key,
          handleResponse
        );
      } else {
        reqTracker(
          APIAndData[key].api,
          { ...body, ...APIAndData[key].data },
          key,
          handleResponse
        );
      }
    } else {
      for (let idx in APIAndData[key].listeners) {
        failed[APIAndData[key].listeners[idx][0]] = true;
      }
    }
  }

  for (let idx in graphs) {
    if (failed[graphs[idx].props.data.key] === true) {
      graphs[idx].draw([], 0, Date.now(), 1);
      graphs[idx].setNoData(true);
    }
  }
};

const makeMarker = (i, title, icon) => {
  let marker = new window.google.maps.Marker({
    title: title,
    position: { lat: i.lat, lng: i.lng },
    map: window.map,
    icon: {
      url: icon,
      scaledSize: new window.google.maps.Size(38, 38),
    },
  });
  marker.addListener("click", (e) => {
    window.map.setCenter({ lat: i.lat, lng: i.lng });
    if (window.map.getZoom() < 17) window.map.setZoom(17);
    window.callInGraph2Listeners("zoom", {
      xDomainValue: [i.starttime - 5 * 60 * 1000, i.endtime + 5 * 60 * 1000],
    });
  });
  return marker;
};

const clearPilferageMarkers = () => {
  if (window.pilferagemarkers) {
    let markers = window.pilferagemarkers;
    for (var idx in markers) {
      markers[idx].setMap(null);
    }
    window.pilferagemarkers.length = 0;
  }
};
window.clearPilferageMarkers = clearPilferageMarkers;

const clearRefuelMarkers = () => {
  if (window.refuelmarkers) {
    let markers = window.refuelmarkers;
    for (var idx in markers) {
      markers[idx].setMap(null);
    }
    window.refuelmarkers.length = 0;
  }
};
window.clearRefuelMarkers = clearRefuelMarkers;

const getVehicle = () => {
  let vehicle = null;

  if (
    window.selectedVehicles &&
    window.selectedVehicles[0] &&
    window.selectedVehicles[0].data
  ) {
    vehicle = window.selectedVehicles[0].data;
  }

  return vehicle;
};

let dataid = Date.now();
const multiSelectStateChange = (state, multiSelect) => {
  let newMap = {};

  for (let idx in state.vehicleMap) {
    if (
      idx.indexOf("user") === -1 ||
      (state.userInfo.SELF &&
        state.userInfo.SELF.ui_custom_stats &&
        state.userInfo.SELF.ui_custom_stats.indexOf("users") !== -1)
    ) {
      newMap[idx] = state.vehicleMap[idx];
      if (newMap[idx].type === "user") {
        newMap[idx].vehicleid = newMap[idx].userid;
      }
    }
  }

  multiSelect.setData({
    dataid,
    data: newMap,
    name: "vehicleno",
    id: "vehicleid",
  });
};

const onVehicleSelectChange = (items, state) => {
  state.dispatch({
    type: actions.SELECTED_VEHICLE_UPDATED,
    data: items,
  });
  window.selectedVehicles = items;
};

const getHistoryStats = (key, unit = "") => {
  return window.graphHistoryStats && window.graphHistoryStats[key]
    ? parseFloat(window.graphHistoryStats[key]).toFixed(2) + " " + unit
    : "No Data";
};

const getHistoryStatsDiff = (key1, key2, unit = "") => {
  if (
    window.graphHistoryStats &&
    window.graphHistoryStats[key1] &&
    window.graphHistoryStats[key2]
  ) {
    return (
      parseFloat(
        window.graphHistoryStats[key1] - window.graphHistoryStats[key2]
      ).toFixed(2) +
      " " +
      unit
    );
  }
  return "No Data";
};

const downloadSummary = (schema, schemaData) => {
  // mixpanel.track("User Downloads History Report", {
  //   Platform: "Web",
  //   Application: "Web",
  //   Screen: "Report",
  // });
  let vehicle =
    window.selectedVehicles && window.selectedVehicles[0]
      ? window.selectedVehicles[0].data
      : null;
  if (!vehicle) return;

  let model = vehicle.vehiclemeta.model;
  let vehicleno = vehicle.vehicleno;
  let devices = vehicle.devices;
  let vehicleData = schemaData.vehicle[0];
  let fueltype = vehicleData.data.vehicleModel.fueltype;
  let instalTyle = vehicle.vehiclemeta.installation_type
  console.log("vehicle type",fueltype)
  const isEvCheck = () => {
    if(fueltype === "EV" ) return true;
  }
  // let startTime = schemaData.starttime.format(dateFormat);
  // let endTime = schemaData.endtime.format(dateFormat);
  let startTime = moment(window.historyStartTime).format('DD-MMM-yy  hh:mm A');
  let endTime = moment(window.historyEndTime).format('DD-MMM-yy  hh:mm A');
  let startfuel = getHistoryStats("startfuel", "%");
  let fuelused = getHistoryStats("fuelused", !isEvCheck() ?" Ltr" : "");
  let endfuel = getHistoryStats("endfuel", "%");
  let mileage = getHistoryStats("mileage", !isEvCheck() ? "kmpl" : "NA");
  let distance = getHistoryStats("distance", "km");
  let distanceCAN = getHistoryStats("distanceCAN", "km");
  let distanceDiff = getHistoryStatsDiff("distance", "distanceCAN", "Km");
  let startodo = getHistoryStats("startodo", "km");
  let startododCAN = getHistoryStats("startodoCAN", "km");
  let startodoDiff = getHistoryStatsDiff("startodo", "startodoCAN", "Km");
  let endodo = getHistoryStats("endodo", "km");
  let endodoCAN = getHistoryStats("endodoCAN", "km");
  let endodoDiff = getHistoryStatsDiff("endodo", "endodoCAN", "Km");
  let maxSpeed = getHistoryStats("maxspeed", "kmph");
  let maxSpeedCAN = getHistoryStats("maxspeedCAN", "kmph");
  let maxSpeedDiff = getHistoryStatsDiff("maxspeed", "maxspeedCAN", "Kmph");
  
  let startloc = {
    lat: window.graphControlData[0]
      ? window.graphControlData[0].latitude
      : null,
    lng: window.graphControlData[0]
      ? window.graphControlData[0].longitude
      : null,
  };
  let endloc = {
    lat: window.graphControlData[window.graphControlData.length - 1].latitude,
    lng: window.graphControlData[window.graphControlData.length - 1].longitude,
  };
  let alarmProcessed = {};

  for (let idx in window.alarmData) {
    if (
      window.alarmData[idx].alarmtype &&
      window.alarmData[idx].alarmtype.indexOf("_RESOLVED") === -1
    ) {
      if (!(window.alarmData[idx].alarmtype in alarmProcessed)) {
        alarmProcessed[window.alarmData[idx].alarmtype] = [];
      }
      alarmProcessed[window.alarmData[idx].alarmtype].push(
        window.alarmData[idx]
      );
    }
  }

  let overSpeed = (window.alarmData || []).filter((i) => {
    return (
      i.alarmtype &&
      (i.alarmtype.indexOf("OVERSPEED") !== -1 ||
        i.alarmtype.indexOf("Over_speed_Start") !== -1)
    );
  });
  let jData = [];
  let locationBody = [
    [startloc.lat, startloc.lng],
    [endloc.lat, endloc.lng],
  ];

  GeoCodeAPIs.getAddress(locationBody).then(
    (resp) => {
      let startLocation = resp[0] && resp[0][1] ? resp[0][1] : "" ;
      let endLocation = resp[1] && resp[1][1] ? resp[1][1] : "";
      addRow("Vehicle No", vehicleno, "", "Model", model, jData);
      addRow("Installation Type",instalTyle,"","","", jData)
      addRow("Start Time", startTime, "End Time", endTime, "", jData);
      addRow(
        !isEvCheck() ? "Fuel Consumed (ltr)": "SOC",
        fuelused,
        !isEvCheck() ? "Mileage (kmpl)" : "",
        !isEvCheck() ?  mileage : "",
        "",
        jData
      );
      addRow(
        !isEvCheck() ? "Start Fuel (ltr)" : "Start SOC",
        startfuel,
        !isEvCheck() ? "End Fuel (ltr)" : "End SOC",
        endfuel,
        "",
        jData
      );
      addRow("", "", "", "", "", jData);
      addRow("Devices", "", "", "", "", jData);
      addRow("Device Name", "Device ID", "", "", "", jData);
      for (let idx in devices) {
        addRow(
          devices[idx].devicetype,
          devices[idx].deviceno,
          "",
          "",
          "",
          jData
        );
      }
      addRow("", "", "", "", "", jData);
      addRow("", "GPS", "CAN", "", "", jData);
      addRow("Maxspeed (kmph)", maxSpeed, maxSpeedCAN, "", "", jData);
      addRow("Distance (km)", distance, distanceCAN, "", "", jData);
      addRow("Start Odo (km)", startodo, startododCAN, "", "", jData);
      addRow("End Odo (km)", endodo, endodoCAN, "", "", jData);
      addRow(
        "Start Location",
        "",
        "",
        "",
        startLocation + " (" + locationBody[0].join(",") + ")",
        jData
      );
      addRow(
        "End Location",
        "",
        "",
        "",
        endLocation + " (" + locationBody[1].join(",") + ")",
        jData
      );

      addRow("", "", "", "", "", jData);
      addRow("Alarm Report", "", "", "", "", jData);

      for (let key in alarmProcessed) {
        addRow(key, alarmProcessed[key].length, "", "", "", jData);
      }

      addRow("", "", "", "", "", jData);

      addRow("Over Speeding Alerts", overSpeed.length, "", "", "", jData);
      if (overSpeed.length) {
        for (let idx in overSpeed) {
          addRow(
            "Instance " + (parseInt(idx) + 1),
            moment(overSpeed[idx].time).format(dateFormat + ":ss"),
            overSpeed[idx].speed + " kmph",
            "",
            "",
            jData
          );
        }
      }

      window.downloadData = jData;
      // console.log("Jdata",jData)

      JSONToCSVConvertor(jData, "History Summary Report", false, false);
    },
    (resp) => {
      console.log(resp);
    }
  );
};

// function addRow(d1, d2, d3, d4, d5, data) {
//   data.push({
//     "col 1": d1,
//     "col 2": d2,
//     "col 3": d3,
//     "col 4": d4,
//     "col 5": d5,
//   });
// }

const graphDataDownload = (graph, config) => {
  let data = graph.ref.getData(true);
  data =
    data && data.data && data.data[0] && data.data[0].data
      ? data.data[0].data[0]
      : [];
  let vehicle =
    window.selectedVehicles && window.selectedVehicles[0]
      ? window.selectedVehicles[0].data
      : null;
  if (!vehicle || !data) return;

  let processedData = [];
  let tempObject = null;
  let status = false;
  let prevStatus = false;
  let name = config.name;

  let currentObject;
  let engineStatus = 0;
  let engineStartTime = null;
  let prevEngineStatus = 0;

  processedData.push({ col1: name + " Report", col2: "" });
  processedData.push({ col1: "", col2: "" });
  processedData.push({ col1: "Vehicle No", col2: vehicle.vehicleno + "" });
  processedData.push({
    col1: "Vehicle Model",
    col2: vehicle.vehiclemeta.model,
  });
  processedData.push({
    col1: "Abused",
    col2: name + " On and Engine Off > 180 sec",
  });
  processedData.push({ col1: "", col2: "" });
  processedData.push({
    col1: "Start Time",
    col2: "End Time",
    col3: "Duration [sec]",
    col4: "Engine Running Time [sec]",
    col5: name + " On Time w/o Engine On [sec]",
    col6: "Vehicle Abuse",
  });

  for (let idx in data) {
    currentObject = data[idx];
    status = currentObject.value;
    engineStatus = currentObject.rpm > 200;
    if (!prevStatus && status && tempObject === null) {
      tempObject = {
        starttime: currentObject.time,
        runningTime: 0,
      };
      if (engineStatus) {
        engineStartTime = currentObject.time;
      }
    } else if (prevStatus && !status && tempObject) {
      let jObj = {};
      jObj["col1"] = moment(tempObject.starttime).format(dateFormat);
      jObj["col2"] = moment(currentObject.time).format(dateFormat);
      jObj["col3"] = (currentObject.time - tempObject.starttime) / 1000;
      jObj["col4"] = tempObject.runningTime / 1000;
      jObj["col5"] = jObj["col3"] - jObj["col4"];
      jObj["col6"] = jObj["col3"] - jObj["col4"] > 180 ? "Abused" : "";
      processedData.push(jObj);
      tempObject = null;
    }
    prevStatus = status;

    /*
     *   Engine
     * */

    if (!prevEngineStatus && engineStatus) {
      engineStartTime = currentObject.time;
    } else if (!engineStatus && prevEngineStatus) {
      if (tempObject) {
        tempObject.runningTime += currentObject.time - engineStartTime;
        engineStartTime = null;
      }
    }
    prevEngineStatus = engineStatus;
  }

  if (tempObject !== null) {
    tempObject.runningTime += currentObject.time - engineStartTime;
    engineStartTime = null;
    let jObj = {};
    jObj["col1"] = moment(tempObject.starttime).format(dateFormat);
    jObj["col2"] = moment(currentObject.time).format(dateFormat);
    jObj["col3"] = (currentObject.time - tempObject.starttime) / 1000;
    jObj["col4"] = tempObject.runningTime / 1000;
    jObj["col5"] = jObj["col3"] - jObj["col4"];
    jObj["col6"] = jObj["col3"] - jObj["col4"] > 180 ? "Abused" : "";
    processedData.push(jObj);
  }

  JSONToCSVConvertor(processedData, name + " Report", false, false);
};

const processTPMSGraphData = (resp, config, configIndex, configData) => {
  if (configIndex === 2) return resp;

  let data = [];
  for (let idx in configData.multiLinesParams) {
    data.push(resp[configData.multiLinesParams[idx]]);
  }

  return data;
};

const getTPMSGraphConfig = (axil, axilID, side) => {
  let tireIds = axil.map((i) => {
    return i.tyreid;
  });
  return {
    key: "tpmsgraph" + side + axilID,
    type: schemaTypes.IN_GRAPH,
    dynamicGraph: true,
    graphType: "graph",
    processData: processTPMSGraphData,
    multiLinesParams: tireIds,
    position: { width: 6, height: 10, left: 6, top: 0 },
    graphToolBar: [
      {
        key: "graphDownload",
        buttonName: "Raw Data ",
        icon: "fa fa-download",
        onClick: graphMetricDownload,
        type: "BUTTON",
        name: "Temperature-Pressure-Mileage [" + tireIds.join(", ") + "]",
      },
    ],
    config: [
      {
        listenTo: [{ api: "getTPMSHistory", key: "pressure", priority: 1 }],
        color: "#53a1ff",
        key: "pressure",
        name: "Pressure ",
        unit: " psi",
        multiLineNames: tireIds.map((i) => {
          return "Tyre " + i;
        }),
      },
      {
        listenTo: [{ api: "getTPMSHistory", key: "temp", priority: 1 }],
        color: "#ff544b",
        key: "temp",
        name: "Temperature ",
        unit: "°C",
        multiLineNames: tireIds.map((i) => {
          return "Tyre " + i;
        }),
      },
      {
        listenTo: [{ api: "getMileage", key: "value", priority: 1 }],
        color: "#f7ff51",
        key: "value",
        name: "Mileage ",
        unit: "Km",
        disabled: true,
      },
    ],
  };
};

const processTPMSGraphs = (vehicle) => {
  schema.content[1].children = schema.content[1].children.filter(
    (graph) => {
      return !graph.dynamicGraph;
    }
  );
  if (vehicle.tpmsconfig) {
    for (let idx in vehicle.tpmsconfig) {
      schema.content[1].children.push(
        getTPMSGraphConfig(vehicle.tpmsconfig[idx].left, idx, "left")
      );
      schema.content[1].children.push(
        getTPMSGraphConfig(vehicle.tpmsconfig[idx].right, idx, "right")
      );
    }
  }
};

const handleVehicleChange = (vehicle) => {
  if (vehicle && vehicle[0] && vehicle[0].data) {
    window.selectedVehicle = vehicle[0].data;
    processTPMSGraphs(window.selectedVehicle);
    clearGraphListeners();
    processGraphListeners();
  }
};

setTimeout(() => {
  window.addOnSaveVehicleStateListener("history", handleVehicleChange);
});

const processGraphListeners = () => {
  [schema.content[0], ...schema.content[1].children].map((graph) => {
    return graph.config.map((config, configIndex) => {
      return config.listenTo.map((listenTo) => {
        return addAPIListener(listenTo, graph.key, configIndex);
      });
    });
  });
};

const clearGraphListeners = () => {
  [schema.content[0], ...schema.content[1].children].map((graph) => {
    return graph.config.map((config, configIndex) => {
      return config.listenTo.map((listenTo) => {
        return clearAPIListener(listenTo, graph.key, configIndex);
      });
    });
  });
};

const getHeadlightStatusByValue = (val) => {
  if (val == 0) return "Off";
  if (val == 1) return "On";
  if (val == 2) return "High Beam";
};

const graphMetricDownload = (graph, config) => {
  let vehicle =
    window.selectedVehicles && window.selectedVehicles[0]
      ? window.selectedVehicles[0].data
      : null;
  if (!vehicle || !graph || !graph.ref || !graph.ref.getData) return;

  let data = graph.ref.getData(true);
  let downloadData = [...data.processedData];
  let filename =
    (config.name ? config.name : "Graph Data") + " Report-" + vehicle.vehicleno;

  const getHeader = (index) => {
    return data.headers ? data.headers[index] : index;
  };

  let tempObj = {};
  for (let idx in data.headers) {
    tempObj[getHeader(idx)] = getHeader(idx);
  }
  downloadData.unshift(tempObj);

  tempObj = {};
  downloadData.unshift(tempObj);

  tempObj = {};
  tempObj[getHeader(0)] = "Vehicle Model";
  tempObj[getHeader(1)] = vehicle.vehiclemeta.model;
  downloadData.unshift(tempObj);

  tempObj = {};
  tempObj[getHeader(0)] = "Vehicle No";
  tempObj[getHeader(1)] = vehicle.vehicleno;
  downloadData.unshift(tempObj);

  tempObj = {};
  downloadData.unshift(tempObj);

  tempObj = {};
  tempObj[getHeader(0)] = config.name
    ? config.name + " Report"
    : "Graph Data Report";
  downloadData.unshift(tempObj);
  console.log(downloadData);

  JSONToCSVConvertor(downloadData, filename, false, false);
};

const getFuelValue = (value) => {
  let tankCapacity = null;
  if (window.selectedVehicle && window.selectedVehicle.fueltankcapacity) {
    tankCapacity = window.selectedVehicle.fueltankcapacity;
  }

  if (
    window.selectedVehicle &&
    window.selectedVehicle.vehicleModel &&
    window.selectedVehicle.vehicleModel.fueltype === "EV"
  ) {
    tankCapacity = tankCapacity ? tankCapacity : 100;
  }

  value = parseFloat(parseFloat(value).toFixed(1));
  tankCapacity = parseInt(tankCapacity);

  if (tankCapacity === null || isNaN(tankCapacity || isNaN(value))) {
    return false;
  }

  if (
    window.selectedVehicles && window.selectedVehicles[0] && window.selectedVehicles[0].data.vehicleModel.fueltype === "EV"
  ) {
    if (window.selectedVehicles[0].data.vehicleModel.vehicletype.toLowerCase() === "bike")
      return "Charge : " + value + "%";
    return "SoC: " + value + "%";
  }

  return (
    "Fuel : " +
    value +
    "%, " +
    parseFloat((value / 100) * tankCapacity).toFixed(1) +
    " Ltr"
  );
};
const getState = (value) => {
  if(window.selectedVehicles && window.selectedVehicles[0]){
    if(selectedId != window.selectedVehicles[0].id){
      selectedId = window.selectedVehicles[0].id
      let vehicleid = window.selectedVehicles[0].id
      let body = {
        vehicleid: vehicleid
      }
      ReportAPIs.getGearMapping(body).then( resp => {
        gearMeta = JSON.parse(resp.meta)
      })
    }
    if(gearMeta && gearMeta.gear_mapping && value in gearMeta.gear_mapping ) {
      return  "Gear state: " + gearMeta.gear_mapping[value]
    }
  }
}
export const range_switch_allowed_groups = ["Bepari"];

const setError = (state, schema, err) => {
  window.graphControlData = null;
  window.graphDataErr = err;
  if (window.InMapForceUpdate) {
    window.InMapForceUpdate();
  }
  if (window.InGraphControlForceUpdate) {
    window.InGraphControlForceUpdate();
  }
  state.dispatch({
    type: actions.GRAPHSET_STATE_CHANGED,
    data: 0,
  });
  if (window.setReportWindowTabBusy)
    window.setReportWindowTabBusy(schema, false);
};

export const onFetchOdo = (cb) => {
  return (schema, data, state, item, gpsOnly = true) => {
    if (!data.vehicle[0] || !data.starttime || !data.endtime) return;

    let start = parseInt(data.starttime, 10);
    let end = parseInt(data.endtime, 10);
    if (start > end) {
      return setError(
        state,
        schema,
        "Start odometer cannot be greater than end odometer"
      );
    }
    if (end - start > 5000) {
      return setError(
        state,
        schema,
        "Please select odometer range lesser than 5000"
      );
    }
    ReportAPIs.getTimestampsFromOdometer({
      vehicleid: data.vehicle[0].id,
      startodo: start,
      endodo: end,
    })
      .then((rsp) => {
        data.starttime = moment(parseInt(rsp.starttime, 10));
        data.endtime = moment(parseInt(rsp.endtime, 10));
        cb(schema, data, state, item, gpsOnly);
      })
      .catch((err) => {
        if (err.response) {
          setError(state, schema, err.response.data.msg);
        }
      });
  };
};

export const flipRange = function (cb) {
  return (schema, data, state, item) => {
    this.odometerRange = !this.odometerRange;
    if (this.odometerRange) {
      schema.toolbar[2].type = schemaTypes.INPUT_NUMBER;
      schema.toolbar[3].type = schemaTypes.INPUT_NUMBER;
      schema.toolbar[2].placeholder = "Start Odometer";
      schema.toolbar[3].placeholder = "End Odometer";
      schema.toolbar[2].model = "";
      schema.toolbar[3].model = "";
    } else {
      setTimeRange.call(this);
    }
    if (cb) cb(this);
    window.forceUpdateReportWindow();
  };
};

const flipRangeWrap = flipRange.call(this, (report) => {
  report.schema.toolbar[4].onClick = report.odometerRange
    ? onFetchOdo(getHistory)
    : getHistory;
  report.schema.toolbar[5].onClick = report.odometerRange
    ? onFetchOdo(getStats)
    : getStats;
});

export const canShowRangeSwitch = (tool, props) => {
  let items = window.selectedVehicle;
  let allowed_groups = range_switch_allowed_groups;
  if (items) {
    let canodo =
      ["can_odometer", "can_odc"].indexOf(items.vehiclemeta.odofrom) > -1;
    let allow_group = false;
    let groups = props.groupTree.children;
    for (let i in groups) {
      if (allowed_groups.indexOf(groups[i].name) > -1) allow_group = true;
    }
    return canodo && allow_group;
  }
  return false;
};

const setTimeRange = function () {
  schema.toolbar[2].type = schemaTypes.DATE_PICKER;
  schema.toolbar[3].type = schemaTypes.DATE_PICKER;
  schema.toolbar[2].placeholder = "Start time";
  schema.toolbar[3].placeholder = "End time";
};

export const changeVehicle = function (v,keyData) {
  window.canDataVehicle = v && v[0] ? v[0].name : ''
  window.canData = []
  let key =""
  if(keyData && keyData.store && keyData.store.reportWindow && keyData.store.reportWindow.tab && keyData.store.reportWindow.tab.key) {
    key = keyData.store.reportWindow.tab.key
  }else {
    key = keyData
  }
  if(key === 'can_data_report' || this && schema !== undefined && schema.key === "can_data_report"){
    if(window.snaplive === true){
      let schemaData = keyData && keyData.data ? keyData.data.getSchema() : {}
      console.log("keyData",keyData.data.getSchema(),schema)
      getCanDataLiveReport(schemaData)
    }
  }
  const validKeys = ["can_data_dump_report", "jem_can_data_dump_report","bg_can_data_dump_report"];
  // if(key === "can_data_dump_report" || schema && schema.key === "can_data_dump_report")
  if (validKeys.includes(key) || (schema && validKeys.includes(schema.key))) 
    {
    window.graphDataErr = ''
    if (window.InMapForceUpdate) {
      window.InMapForceUpdate();
    }
    if(v &&v[0]) window.metricsClicked = true
    window.metrics = {}
    window.multiselectClear()
    const auth = window.getAuth();
    let metrics = {}
    if(v &&v[0]){
      if((window.dumpTime.starttime > window.dumpTime.endtime) || (window.currentValue.starttime > window.currentValue.endtime) ){
        window.graphDataErr = "The start time should be less than the end time"
        if (window.InMapForceUpdate) {
          window.InMapForceUpdate();
        }
        return
      }
      if(( window.currentValue.endtime - window.currentValue.starttime)> 1000 * 60 * 60 * 24 * 7){
        console.log("inside 7 days check")
        window.graphDataErr = "Selected time is greater than 8 days"
        if (window.InMapForceUpdate) {
          window.InMapForceUpdate();
        }
        return
      }
      let body = {
      // vehicleno: v[0].name,
      vehicleid:v[0].data.vehicleid,
      starttime:window.currentValue.starttime,
      endtime: window.currentValue.endtime,
      token: auth.token
      }
      ReportAPIs.getCanMetrics(body)
      .then((resp) => {
        // console.log(resp, resp.data)
        if(!resp.length){
          window.graphDataErr = "No CAN data metrics found"
          if (window.InMapForceUpdate) {
            window.InMapForceUpdate();
          }
        }
          resp.map((item,index) =>{
              metrics[index] ={
                  metrics:item,
                  id:index
              }
          })
          window.metrics = metrics
          setTimeout(() => {
            window.multiselectUpdate();
            if(key === "can_data_dump_report"){
              window.metricsClicked = false
            }
          },1000)
      })
    }
  }
  if (this && this.odometerRange) {
    setTimeRange.call(this);
  }
  window.saveVehicleState(v);
};

window.expandGraphs = (width = 12, large = false) => {
  schema.content[1].position.width = width;
  window.graphLarge = large;
  // window.dispatchEvent(new Event('resize'));
};

const voltageLine = (vh) => {
  let hasIntelliblu = vh.deviceTypesList.includes("intelliblu");
  return hasIntelliblu
    ? {
        listenTo: [{ api: "getFuelLevelInfo", key: "voltage", priority: 2 }],
        yScale: [0, 90],
        color: "#fff728",
        name: "Voltage",
      }
    : null;
};

const showAdvancedReports = () => {

  if (_.get(window.userInfo, "SELF.advanced_reports") === "HIDE") return false;
  return true;
};

const schema = {
  key: "history_report",
  name: "History",
  graphData: {},
  noFitBounds:null,
  latestFuelDep:null,
  showAlarms:false,
  toolbar: [
    {
      key: "vehicle",
      type: schemaTypes.MULTI_SELECT,
      onClick: onVehicleSelectChange,
      onItemChange: changeVehicle.bind(this),
      onStateChange: multiSelectStateChange,
      singleSelect: true,
      defaultValue: () => {
        return {
          data: window.selectedVehicles.map((i) => {
            return i.id;
          }),
          updatedAt: window.selectedVehiclesUpdatedAt,
        };
      },
    },
    {
      key: "switch",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-exchange",
      onClick: flipRangeWrap,
      tooltip: "Switch between date range and odometer",
      isShowable: canShowRangeSwitch,
    },
    {
      key: "starttime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      model: moment().subtract(1, "days").startOf("day"),
    },
    {
      key: "endtime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      model: moment(Date.now()).add(0, "day").startOf("day"),
    },
    {
      key: "toggle",
      type: schemaTypes.TOGGLE,
    },
    {
      key: "get_history",
      type: schemaTypes.BUTTON,
      name: "Show Route",
      onClick: getHistory,
      alignRight: true,
    },
    {
      key: "get_stats",
      type: schemaTypes.BUTTON,
      name: "Show Driving Report",
      onClick: getStats,
      alignRight: true,
      isShowable: showAdvancedReports,
    },
    {
      key: "download",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-download",
      onClick: downloadSummary,
    },
  ],
  content: [
    {
      key: "gpsspeed",
      type: schemaTypes.IN_GRAPH_CONTROL,
      controller: true,
      position: { width: 12, height: 2, left: 0, top: 10 },
      style: { zIndex: 10 },
      legends: [
        { name: "Ignition", color: "#3498db" },
        { name: "Moving", color: "#29b464" },
        { name: "Speed", color: "#ff4144" },
      ],
      config: [
        { listenTo: [{ api: "getRTGPS", key: "speed" }], color: "#d01c3a" },
      ],
    },
    {
      key: "graphSet",
      type: schemaTypes.IN_GRAPH_SET,
      position: { width: 6, height: 10, left: 12, top: 0 },
      children: [
        // TORK
        {
          key: "torkCurrentHistory",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Current",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "torkCurrentHistory", key: "value" }],
              color: "#2ecc71",
              name: "Current",
            },
          ],
        },
        {
          key: "torkVoltageHistory",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Voltage",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "torkVoltageHistory", key: "value" }],
              color: "#e67e22",
              name: "Voltage",
            },
          ],
        },
        {
          key: "throttleInputVoltageHistory",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Throttle Input Voltage",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "throttleInputVoltageHistory", key: "value" }],
              color: "#e67e22",
              name: "Throttle Input Voltage",
            },
          ],
        },
        
        {
          key: "torkECUTempHistory",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "ECU Temp",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "torkECUTempHistory", key: "value" }],
              color: "#f1c40f",
              name: "ECU Temp",
            },
          ],
        },
        {
          key: "torkTorqueHistory",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Torque",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "torkTorqueHistory", key: "value" }],
              color: "#3498db",
              name: "Torque",
            },
          ],
        },
        // etrio
        {
          key: "torkBatteryVoltageHistory",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Battery Voltage",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "torkBatteryVoltageHistory", key: "value" }],
              color: "#ff2d74",
              name: "Battery Voltage",
            },
          ],
        },
        {
          key: "torkTempHistory",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Temperature",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "torkControllerTempHistory", key: "value" }],
              color: "#ffe041",
              name: "Controller Temperature",
            },
            {
              listenTo: [{ api: "getEngineTempInfo", key: "value" }],
              color: "#6061ff",
              name: "Motor Temp",
              unit: "°C",
            },
          ],
        },
        {
          key: "torkCellVoltageHistory",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Cell Voltage",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "torkMinCellVoltageHistory", key: "value" }],
              color: "#3498db",
              name: "Min Cell Voltage",
            },
            {
              listenTo: [{ api: "torkMaxCellVoltageHistory", key: "value" }],
              color: "#d01c3a",
              name: "Max Cell Voltage",
            },
          ],
        },
        {
          key: "torkMotorSpeedHistory",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 0, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Motor Speed",
            },
          ],
          config: [
            {
              listenTo: [{ api: "getRPMInfo", key: "value" }],
              color: "#ffe041",
              name: "Motor Speed",
              unit: "RPM",
            },
          ],
        },
        // END TORK
        {
          key: "odometerGPS",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "GPS Odometer",
            },
          ],
          config: [
            {
              listenTo: [{ api: "getRTGPS", key: "odometer", priority: 1 }],
              color: "#53a1ff",
              normalize: true,
              name: "GPS Odometer",
              unit: "km",
            },
          ],
        },
        {
          key: "odometer",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          depAPIs: ["getClutchData", "getBrakeData", "getAccelData"],
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "CAN Odometer",
            },
          ],
          config: [
            {
              listenTo: [{ api: "getOdometerInfo", key: "value", priority: 1 }],
              color: "#ff2d74",
              normalize: true,
              name: "Dash Odometer",
              unit: "km",
            },
          ],
        },
        {
          key: "devicebattery",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Battery",
            },
          ],
          config: [
            {
              listenTo: [
                { api: "getBatteryInfo", key: "devbattery", priority: 2 },
                { api: "getRTGPS", key: "devbattery", priority: 1 },
              ],
              yScale: [0, 130],
              color: "#82ff59",
              name: "Device Battery",
              unit: "%",
            },
          ],
        },
        {
          key: "speedGPS",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 0, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "GPS Speed",
            },
          ],
          config: [
            {
              listenTo: [{ api: "getRTGPS", key: "speed" }],
              color: "#d01c3a",
              name: "GPS Speed",
              unit: "km/h",
            },
          ],
        },
        {
          key: "speed",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 0, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "CAN Speed",
            },
          ],
          config: [
            {
              listenTo: [{ api: "getSpeedInfo", key: "value" }],
              color: "#ff394a",
              name: "Dash Speed",
              unit: "km/h",
            },
          ],
        },
        {
          key: "battery",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Battery",
            },
          ],
          config: [
            {
              listenTo: [
                { api: "getBatteryInfo", key: "carbattery", priority: 2 },
                { api: "getRTGPS", key: "carbattery", priority: 1 },
              ],
              color: "#ff3557",
              name: "Vehicle Battery",
              unit: "V",
            },
            {
              listenTo: [
                { api: "getBatteryInfo", key: "devbattery", priority: 2 },
                { api: "getRTGPS", key: "devbattery", priority: 1 },
              ],
              color: "#6061ff",
              name: "Device Battery",
              unit: "V",
            },
            // voltageLine,
          ],
        },
        {
          key: "min_cell_vol",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 0, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Min Cell Voltage",
            },
          ],
          config: [
            {
              listenTo: [{ api: "minCellVol", key: "value" }],
              color: "#ff394a",
              name: "Min Cell Voltage",
              // unit: "km/h",
            },
          ],
        },
        {
          key: "max_cell_vol",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 0, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Max Cell Voltage",
            },
          ],
          config: [
            {
              listenTo: [{ api: "maxCellVol", key: "value" }],
              color: "#ff394a",
              name: "Max Cell Voltage",
              // unit: "km/h",
            },
          ],
        },
        {
          key: "cell_temp",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "CellTemp",
            },
          ],
          config: [
            {
              listenTo: [
                { api: "minCellTemp", key: "value", priority: 1 },
              ],
              color: "#6061ff",
              name: "min cell temp  ",
              unit: "°C",
            },
            {
              listenTo: [
                { api: "maxCellTemp", key: "value", priority: 1 },
              ],
              color: "#ff3557",
              name: "max cell temp",
              unit: "°C",
            },
            // // voltageLine,
          ],
        },
        {
          key: "direction",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 0, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Direction",
            },
          ],
          config: [
            {
              listenTo: [{ api: "getDirection", key: "value" }],
              color: "#ff394a",
              name: "Direction",
              // unit: "km/h",
            },
          ],
        },
        {
          key: "mcu_fault_codes",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 0, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "MCU Fault Codes",
            },
          ],
          config: [
            {
              listenTo: [{ api: "getMcuFaultInfo", key: "value" }],
              color: "#ff394a",
              name: "MCU fault Codes",
              // unit: "km/h",
            },
          ],
        },
        {
          key: "limp_home_mode",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 0, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Limp Home Mode",
            },
          ],
          config: [
            {
              listenTo: [{ api: "LimpModeInfo", key: "value" }],
              color: "#ff394a",
              name: "Limp Home Mode",
              // unit: "km/h",
            },
          ],
        },
        {
          key: "charging_status",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 0, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Charging Status",
            },
          ],
          config: [
            {
              listenTo: [{ api: "getChargingStatusInfo", key: "value" }],
              color: "#ff394a",
              name: "Charging Status",
              // unit: "km/h",
            },
          ],
        },
        {
          key: "t_min",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 0, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Min Temp",
            },
          ],
          config: [
            {
              listenTo: [{ api: "minTemp", key: "value" }],
              color: "#ff394a",
              name: "Min Temp",
              // unit: "km/h",
            },
          ],
        },
        {
          key: "t_average",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 0, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Average Temp",
            },
          ],
          config: [
            {
              listenTo: [{ api: "avgTemp", key: "value" }],
              color: "#ff394a",
              name: "Average Temp",
              // unit: "km/h",
            },
          ],
        },
        {
          key: "ac_dc_charging",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 0, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "AC DC Charging",
            },
          ],
          config: [
            {
              listenTo: [{ api: "acDcCharging", key: "value" }],
              color: "#ff394a",
              name: "AC DC Charging",
              // unit: "km/h",
            },
          ],
        },
        {
          key: "hill_assist_status",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 0, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Hill Assist Status",
            },
          ],
          config: [
            {
              listenTo: [{ api: "getHillAssistInfo", key: "value" }],
              color: "#ff394a",
              name: "Hill Assist Status",
              // unit: "km/h",
            },
          ],
        },
        {
          key: "overcurrent_error",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 0, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Over Current Error",
            },
          ],
          config: [
            {
              listenTo: [{ api: "getOverCurrentInfo", key: "value" }],
              color: "#ff394a",
              name: "Over Current Error",
              // unit: "km/h",
            },
          ],
        },
        {
          key: "immobilize_sts",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 0, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Immobilize Sts",
            },
          ],
          config: [
            {
              listenTo: [{ api: "getImmobInfo", key: "value" }],
              color: "#ff394a",
              name: "Immobilize Sts",
              // unit: "km/h",
            },
          ],
        },
        {
          key: "immobilize_enable_ack",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 0, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Immobilize Enable Ack",
            },
          ],
          config: [
            {
              listenTo: [{ api: "getImmobEnableInfo", key: "value" }],
              color: "#ff394a",
              name: "Immobilize Enable Ack",
              // unit: "km/h",
            },
          ],
        },
        {
          key: "motor_temperature",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 0, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Motor Temperature",
            },
          ],
          config: [
            {
              listenTo: [{ api: "getMotorTempInfo", key: "value" }],
              color: "#ff394a",
              name: "Motor Temperature",
              // unit: "km/h",
            },
          ],
        },
        {
          key: "acceleration_pedal_position",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Throttle",
            },
          ],
          config: [
            {
              listenTo: [
                { api: "throttle", key: "value", priority: 1 },
              ],
              color: "#ff3557",
              name: "Throttle",
              unit: "",
            },
          ],
        },
        {
          key: "battery_temp",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Battery",
            },
          ],
          config: [
            {
              listenTo: [
                { api: "getBatteryTemp",key: "value", priority: 1 },
              ],
              color: "#ff3557",
              name: "Battery Temperature",
              unit: "°C",
            },
            
            // voltageLine,
          ],
        },
        {
          key: "ambient_temp",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Ambient Temperature",
            },
          ],
          config: [
            {
              listenTo: [
                { api: "ambientTemp",key: "value", priority: 1 },
              ],
              color: "#ff3557",
              name: "Ambient Temperature",
              unit: "°C",
            },
          ],
        },
        {
          key: "controller_temperature",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Battery",
            },
          ],
          config: [
            {
              listenTo: [
                { api: "controllerTemperature",key: "value", priority: 1 },
              ],
              color: "#ff3557",
              name: "Controller Temperature",
              unit: "°C",
            },
            
            // voltageLine,
          ],
        },
        {
          key: "bms_temperature",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "BMS Temperature",
            },
          ],
          config: [
            {
              listenTo: [
                { api: "bmsTemperature",key: "bms_temperature", priority: 1 },
              ],
              color: "#ff3557",
              name: "BMS Temperature",
              unit: "°C",
            },
            
            // voltageLine,
          ],
        },
        {
          key: "torkMotorTempHistory",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Motor Temp",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "torkMotorTempHistory", key: "value" }],
              color: "#1abc9c",
              name: "Motor Temp",
            },
          ],
        },
        {
          key: "charge_discharge_cycle",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Charge Discharge Cycle",
            },
          ],
          config: [
            {
              listenTo: [
                { api: "chargeDischargeCycle",key: "value", priority: 1 },
              ],
              color: "#ff3557",
              name: "Charge Discharge Cycle",
              unit: "",
            },
          ],
        },
        {
          key: "battery_current",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Battery",
            },
          ],
          config: [
            {
              listenTo: [
                { api: "getBatteryCurrent",key: "value", priority: 1 },
              ],
              color: "#ff3557",
              name: "Battery Current",
              unit: "A",
            },
            
            // voltageLine,
          ],
        },
        {
          key: "ev_battery_voltage",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Battery",
            },
          ],
          config: [
            {
              listenTo: [
                { api: "getEvBatteryVoltage",key: "voltage", priority: 1 },
              ],
              color: "#ff3557",
              name: "EV Battery Voltage",
              unit: "V",
            },
          ],
        },
        {
          key: "battery_voltage",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Battery",
            },
          ],
          config: [
            {
              listenTo: [
                { api: "getBatteryVoltage",key: "value", priority: 1 },
              ],
              color: "#ff3557",
              name: "Battery Voltage",
              unit: "V",
            },
            
            // voltageLine,
          ],
        },
        {
          key: "fuellevel",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Fuel Level",
            },
          ],
          depAPIs: ["pilferageReport", "getRefuelHistory"],
          config: [
            {
              listenTo: [{ api: "getFuelLevelInfo", key: "value", processData: (d, v) => _.get(v, 'data.vehiclemeta.num_fuelsensors') === 2 ? d[1] : d }],
              color: "#fff900",
              name: "Fuel",
              getValue: getFuelValue,
              unit: "%",
            },
            {
              listenTo: [{ api: "getFuelLevelInfo", key: "value", processData: (d) => d[2] }],
              color: "#a241ff",
              name: "Fuel",
              getValue: getFuelValue,
              unit: "%",
              condition: (v) => _.get(v, 'data.vehiclemeta.num_fuelsensors') === 2,
            },
          ],
        },
        {
          key: "fuellevel_combined",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Fuel Level",
            },
          ],
          depAPIs: ["pilferageReport", "getRefuelHistory"],
          config: [
            {
              listenTo: [{ api: "getFuelLevelCombined", key: "value"}],
              color: "#fff",
              name: "Fuel Combined",
              unit: "%",
            },
          ],
        },
        {
          key: "rpm",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 0, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "RPM",
            },
          ],
          config: [
            {
              listenTo: [{ api: "getRPMInfo", key: "value" }],
              color: "#ffe041",
              name: "Engine Speed",
              unit: "RPM",
            },
          ],
        },
        {
          key: "non_can_soc",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 0, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "SoC",
            },
          ],
          config: [
            {
              listenTo: [{ api: "getEvBatteryVoltage", key: "soc" }],
              color: "#ffe041",
              name: "Derived SoC",
              unit: "%",
            },
          ],
        },
        // {
        //   key: "enginetemp",
        //   type: schemaTypes.IN_GRAPH,
        //   graphType: "graph",
        //   position: { width: 6, height: 10, left: 6, top: 0 },
        //   graphToolBar: [
        //     {
        //       key: "graphDownload",
        //       buttonName: "Raw Data ",
        //       icon: "fa fa-download",
        //       onClick: graphMetricDownload,
        //       type: "BUTTON",
        //       name: "Engine Temp",
        //     },
        //   ],
        //   config: [
        //     {
        //       listenTo: [{ api: "getEngineTempInfo", key: "value" }],
        //       color: "#6061ff",
        //       name: "Engine Temp",
        //       unit: "°C",
        //     },
        //   ],
        // },
        {
          key: "ac",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDataDownload",
              icon: "fa fa-download",
              buttonName: "AC Report",
              onClick: graphDataDownload,
              type: "BUTTON",
              name: "AC",
            },
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              getStatus: getHeadlightStatusByValue,
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "AC Data",
            },
          ],
          config: [
            {
              listenTo: [{ api: "getACInfo", key: "value" }],
              color: "#ff4d4f",
              name: "AC",
            },
          ],
        },
        // {
        //   key: "headLight",
        //   type: schemaTypes.IN_GRAPH,
        //   graphType: "graph",
        //   position: { width: 6, height: 10, left: 6, top: 0 },
        //   graphToolBar: [
        //     {
        //       key: "graphDataDownload",
        //       icon: "fa fa-download",
        //       buttonName: "Headlight Report",
        //       onClick: graphDataDownload,
        //       type: "BUTTON",
        //       name: "Headlightb",
        //     },
        //     {
        //       key: "graphDownload",
        //       buttonName: "Raw Data ",
        //       icon: "fa fa-download",
        //       onClick: graphMetricDownload,
        //       getStatus: getHeadlightStatusByValue,
        //       type: "BUTTON",
        //       name: "Headlightaa",
        //     },
        //   ],
        //   config: [
        //     {
        //       listenTo: [{ api: "getHeadLightInfo", key: "value" }],
        //       color: "#e13dff",
        //       name: "Headlightc",
        //     },
        //   ],
        // },
        {
          key: "distanceGPS_boat",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "GPS Distance",
            },
          ],
          config: [
            {
              listenTo: [{ api: "getRTGPS", key: "distance", priority: 1 }],
              color: "#53a1ff",
              normalize: true,
              name: "GPS Distance",
              unit: "km",
            },
          ],
        },
        {
          key: "numsat",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "GPS Signal",
            },
          ],
          config: [
            {
              listenTo: [{ api: "getRTGPS", key: "numsat" }],
              color: "#6061ff",
              name: "GPS Signal",
            },
          ],
        },
        // {
        //   key: "seatBelt",
        //   type: schemaTypes.IN_GRAPH,
        //   graphType: "graph",
        //   position: { width: 6, height: 10, left: 6, top: 0 },
        //   graphToolBar: [
        //     {
        //       key: "graphDownload",
        //       buttonName: "Raw Data ",
        //       icon: "fa fa-download",
        //       onClick: graphMetricDownload,
        //       getStatus: getHeadlightStatusByValue,
        //       type: "BUTTON",
        //       name: "Seat Belt",
        //     },
        //   ],
        //   config: [
        //     {
        //       listenTo: [{ api: "getSeatBeltInfo", key: "value" }],
        //       color: "#ff9846",
        //       name: "Seat Belt",
        //     },
        //   ],
        // },
        {
          key: "userScore",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "User Score",
            },
          ],
          config: [
            {
              listenTo: [{ api: "getUserScore", key: "value" }],
              color: "#65ff4a",
              name: "User Score",
            },
          ],
        },
        {
          key: "nanoBattery",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Nano Battery",
            },
          ],
          config: [
            {
              listenTo: [{ api: "getNanoBatteryInfo", key: "value" }],
              color: "#ff585a",
              name: "Nano Battery",
            },
          ],
        },
        {
          key: "rssi",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "RSSI",
            },
          ],
          config: [
            {
              listenTo: [{ api: "getRSSIInfo", key: "value" }],
              color: "#6076ff",
              name: "RSSI",
            },
          ],
        },
        {
          key: "magnet",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Magnet",
            },
          ],
          config: [
            {
              listenTo: [{ api: "getMagnetInfo", key: "value" }],
              color: "#ffa037",
              name: "Magnet",
            },
          ],
        },
        {
          key: "ambientLight",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Ambient Light",
            },
          ],
          config: [
            {
              listenTo: [{ api: "getAmbientLightInfo", key: "value" }],
              color: "#63ffe2",
              name: "Ambient Light",
            },
          ],
        },
        {
          key: "distanceGPS",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "GPS Distance",
            },
          ],
          config: [
            {
              listenTo: [
                { api: "getRTGPS", key: "distance", priority: 1 },
                { api: "getDistance", noDraw: true },
              ],
              color: "#53a1ff",
              normalize: true,
              name: "GPS Distance",
              unit: "km",
            },
          ],
        },
        {
          key: "distance",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "DASH Distance",
            },
          ],
          config: [
            {
              listenTo: [
                { api: "getOdometerInfo", key: "distance", priority: 1 },
              ],
              color: "#ff4679",
              normalize: true,
              name: "DASH Distance",
              unit: "km",
            },
          ],
        },
        {
          key: "gearstate",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Gear State",
            },
          ],
          config: [
            {
              listenTo: [
                { api: "getGearStateInfo", key: "value", priority: 1 },
              ],
              color: "#ff4679",
              normalize: true,
              name: "Gear state",
              getValue: getState,
            },
          ],
        },
        {
          key: "gearstatedistribution",
          type: schemaTypes.IN_BAR_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Gear State",
            },
          ],
          config: [
            {
              listenTo: [
                { api: "getGearStateInfo", key: "value", priority: 1 },
              ],
              name: "Gear state",
            },
          ],
          processBarData: processGearData,
          graphSetName: "Gear distribution",
        },
        {
          key: "drive_mode",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Drive Mode",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "driveModeHistory", key: "value" }],
              color: "#e67e22",
              name: "Drive Mode",
            },
          ],
        },

        {
          key: "pulsegraph",
          type: schemaTypes.IN_GRAPH,
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Pulse",
            },
          ],
          config: [
            {
              listenTo: [{ api: "pulseHistory", key: "value", priority: 1 }],
              color: "#ff4679",
              normalize: true,
              name: "Pulse",
            },
          ],
        },

        // User APIs

        {
          key: "phoneBatteryHistory",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "DASH Distance",
            },
          ],
          config: [
            {
              listenTo: [
                { api: "phoneBatteryHistory", key: "value", priority: 1 },
              ],
              color: "#56ff46",
              name: "Battery",
            },
          ],
        },
        {
          key: "userSignal",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Battery",
            },
          ],
          config: [
            {
              listenTo: [
                { api: "cellInfoHistory", key: "signalstrength1", priority: 1 },
              ],
              yScale: [-150, 200],
              color: "#ff4679",
              name: "Signal Strength 1",
            },
            {
              listenTo: [
                { api: "cellInfoHistory", key: "signalstrength2", priority: 1 },
              ],
              yScale: [-150, 200],
              color: "#8746ff",
              name: "Signal Strength 2",
            },
          ],
        },

        // Paver Graphs
        {
          key: "getBaseScreedTemperature",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Base Screed Temp",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "getBaseScreedTemperature", key: "value" }],
              color: "#63ffe2",
              name: "Base Screed Temp",
            },
          ],
        },
        {
          key: "getLeftScreedTemperature",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Left-Right Screed Temp",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "getLeftScreedTemperature", key: "value" }],
              color: "#63ffe2",
              name: "Left Screed Temp",
            },
            {
              listenTo: [{ api: "getLeftScreedTemperature", key: "value" }],
              color: "#63ffe2",
              name: "Right Screed Temp",
            },
          ],
        },
        {
          key: "getActualEngineSpeed",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Engine Speed",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "getActualEngineSpeed", key: "value" }],
              color: "#63ffe2",
              name: "Engine Speed",
              unit: "RPM",
            },
          ],
        },
        {
          key: "getEngineHours",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Engine Hours",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "getEngineHours", key: "value" }],
              color: "#63ffe2",
              name: "Engine Hours",
            },
          ],
        },
        {
          key: "getPavingDistance",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Engine Hours",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "getPavingDistance", key: "value" }],
              color: "#63ffe2",
              name: "Paving Distance",
            },
          ],
        },
        {
          key: "getTravelDistanceHighGear",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Distance in High/Low Gear",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "getTravelDistanceHighGear", key: "value" }],
              color: "#63ffe2",
              name: "Distance in High Gear",
            },
            {
              listenTo: [{ api: "getTravelDistanceLowGear", key: "value" }],
              color: "#63ffe2",
              name: "Distance in Low Gear",
            },
          ],
        },
        {
          key: "getBatteryChargeIndication",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Battery Charge",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "getBatteryChargeIndication", key: "value" }],
              color: "#63ffe2",
              name: "Battery Charge",
            },
          ],
        },
        {
          key: "getLowGearMoving",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Low Gear Moving/Idle",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "getLowGearMoving", key: "value" }],
              color: "#63ffe2",
              name: "Low Gear Moving",
            },
            {
              listenTo: [{ api: "getLowGearIdle", key: "value" }],
              color: "#63ffe2",
              name: "Low Gear Idle",
            },
          ],
        },
        {
          key: "getScreenHeatingMode",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Screed Heating Mode",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "getScreenHeatingMode", key: "value" }],
              color: "#63ffe2",
              name: "Screed Heating Mode",
            },
          ],
        },
        {
          key: "getWorkTimeHours",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Work Time Hours",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "getWorkTimeHours", key: "value" }],
              color: "#63ffe2",
              name: "Work Time Hours",
            },
          ],
        },

        // KPTL Temperature
        {
          key: "temperature",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Temperature",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "getTemperatureHistory", key: "sensor1" }],
              color: "#63ffe2",
              name: "Temperature",
            },
            // {listenTo:[{api:'getTemperatureHistory', key:'sensor2'}], color: "#ff6363", name:'Temperature 2'},
          ],
        },
        
        {
          key: "pressure",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Pressure",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "getPressureHistory", key: "value" }],
              color: "#8746ff",
              name: "Pressure",
            },
          ],
        },

        // TVS Graphs
        ...(() => {
          return [
            // {key: 'tvs_acc', name: '', color: ''},
            { key: "tvs_rpm", name: "RPM", color: "#2ecc71" },
            { key: "tvs_speed", name: "Speed", color: "#e67e22" },
            { key: "tvs_rspeed", name: "Rear Speed", color: "#1abc9c" },
            { key: "tvs_finn", name: "Finn Temp", color: "#f1c40f" },
            { key: "tvs_fuel", name: "Fuel", color: "#3498db" },
            { key: "tvs_oiltemp", name: "Oil Temp", color: "#9b59b6" },
            { key: "tvs_throttle", name: "Throttle", color: "#f1c40f" },
            { key: "tvs_battery_amp", name: "Battery AMP", color: "#1abc9c" },
            { key: "tvs_battery_volt", name: "Battery Volt", color: "#3498db" },
            { key: "tvs_diff", name: "Diff Temp", color: "#9b59b6" },
            { key: "tvs_map", name: "MAP", color: "#3498db" },
            { key: "tvs_frontodo", name: "Front ODO", color: "#e67e22" },
            { key: "tvs_rearodo", name: "Rear ODO", color: "#e74c3c" },
          ].map((g) => {
            return {
              key: g.key,
              processData: processTVSData,
              graphToolBar: [
                {
                  key: "graphDownload",
                  buttonName: "Raw Data ",
                  icon: "fa fa-download",
                  onClick: graphMetricDownload,
                  type: "BUTTON",
                  name: "RPM",
                },
              ],
              type: schemaTypes.IN_GRAPH,
              graphType: "graph",
              position: { width: 6, height: 10, left: 6, top: 0 },
              config: [
                {
                  listenTo: [{ api: "getTvsHistory", key: "value" }],
                  color: g.color,
                  name: g.name,
                },
              ],
            };
          });
        })(),

        // greenfuel
        {
          key: "soh",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "SOH",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "sohHistory", key: "value" }],
              color: "#2ecc71",
              name: "SOH",
            },
          ],
        },
        {
          key: "charge_type",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Charge Type",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "chargeTypeHistory", key: "value" }],
              color: "#2ecc71",
              name: "Charge Type",
            },
          ],
        },
        {
          key: "kwh",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "KWH",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "kwhHistory", key: "value" }],
              color: "#e67e22",
              name: "KWH",
            },
          ],
        },
        {
          key: "engine_speed",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Engine Speed",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "engineSpeedHistory", key: "value" }],
              color: "#e67e22",
              name: "Engine Speed",
            },
          ],
        },
        {
          key: "brake_pedal",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Brake Pedal",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "brakePedal", key: "value" }],
              color: "#e67e22",
              name: "Brake Pedal",
            },
          ],
        },
        {
          key: "temperature_can",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Temperature",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "tempHistory", key: "value" }],
              color: "#e67e22",
              name: "Temperature",
            },
          ],
        },
        {
          key: "bms_error_info",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "BMS Error Info",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "bmsErrorInfo", key: "value" }],
              color: "#e67e22",
              name: "BMS Error Info",
            },
          ],
        },
        {
          key: "dte",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "DTE",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "dteHistory", key: "value" }],
              color: "#e67e22",
              name: "DTE",
            },
          ],
        },
        {
          key: "parking_brake",
          graphToolBar: [
            {
              key: "graphDownload",
              buttonName: "Raw Data ",
              icon: "fa fa-download",
              onClick: graphMetricDownload,
              type: "BUTTON",
              name: "Parking Brake",
            },
          ],
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          position: { width: 6, height: 10, left: 6, top: 0 },
          config: [
            {
              listenTo: [{ api: "parkingBrakeHistory", key: "value" }],
              color: "#e67e22",
              name: "Parking Brake",
            },
          ],
        },
   

      ],
    },
  ],
};

processGraphListeners();

export default schema;